<template>
  <div class="statusList quoteLite">
    <v-content>
      <v-container fluid>
        <v-navigation-drawer v-model="filterDrawer" right absolute light width="1000" class="rightDrawer">
          <v-layout row wrap v-if="filtersLoading == true">
            <v-flex lg12>
              <h3>FILTERS LOADING</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="filterContainer" style="padding-bottom: 100px;overflow: scroll !important;" v-if="filtersLoading == false">
              <v-flex lg12 class="card__title modalTitle">
                <h3>FILTERS</h3>
              </v-flex>
            <v-flex lg4 style="margin-bottom: 40px; margin-top: 70px; margin-left: 24px">
              <v-btn @click="fncSearchQuoteLite" color="success">Apply Filters</v-btn>
              <v-btn @click.prevent="fncClearLiteFilters" class="elevation-5 clearFilters">Clear Filters</v-btn>
            </v-flex>

            <v-flex lg6 style="margin-bottom: 40px;" class="closeFiltersBtn">
              <v-btn @click="filterDrawer = false" class="text-xs-right cancelButton btn">Close</v-btn>
            </v-flex>
            <v-flex lg12 class="filterContainerFilters">
              <v-flex lg4 style="position:relative">
                <label><strong>Status</strong></label>
                <a class="filterDone" style="margin-top: 5px;" v-if="fncCheckDone('status')" @click="fncLoadFilters()">Done</a>
                <v-select @blur="fncCheckChange('status')" ref="statusSelect" style="width: 90%;display:block;" class="statusClick dropdown dashDroprep" v-model="filterStatus" :items="quotesLiteFilters.status" @input="fncCheckDropdowns('status')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Store</strong></label>
                <a class="filterDone" v-if="fncCheckDone('store')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="storeSelect" @blur="fncCheckChange('store')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterStore"  :items="quotesLiteFilters.store" @input="fncCheckDropdowns('store')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Department</strong></label>
                <a class="filterDone" v-if="fncCheckDone('department')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="departmentSelect" @blur="fncCheckChange('department')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterDepartment"  :items="quotesLiteFilters.department" @input="fncCheckDropdowns('department')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Customer</strong></label>
                <a class="filterDone" v-if="fncCheckDone('customer')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="customerSelect" @blur="fncCheckChange('customer')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterCustomer"  :items="quotesLiteFilters.customer" @input="fncCheckDropdowns('customer')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Vendor</strong></label>
                <a class="filterDone" v-if="fncCheckDone('vendor')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="vendorSelect" @blur="fncCheckChange('vendor')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterVendor"  :items="quotesLiteFilters.vendor" @input="fncCheckDropdowns('vendor')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Company</strong></label>
                <a class="filterDone" v-if="fncCheckDone('company')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="companySelect" @blur="fncCheckChange('company')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterCompany"  :items="quotesLiteFilters.company" @input="fncCheckDropdowns('company')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Originator</strong></label>
                <a class="filterDone" v-if="fncCheckDone('originator')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="originatorSelect" @blur="fncCheckChange('originator')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterOriginator"  :items="quotesLiteFilters.originator" @input="fncCheckDropdowns('originator')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Project</strong></label>
                <a class="filterDone" v-if="fncCheckDone('project')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="projectSelect" @blur="fncCheckChange('project')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterProject"  :items="quotesLiteFilters.project" @input="fncCheckDropdowns('project')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
            <v-flex lg4 style="position:relative">
              <label><strong>Service Type</strong></label>
              <a class="filterDone" v-if="fncCheckDone('service_type')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
              <v-select ref="serviceTypeSelect" @blur="fncCheckChange('service_type')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterServiceType"  :items="quotesLiteFilters.serviceType" @input="fncCheckDropdowns('service_type')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
            </v-flex>
              <v-flex lg4 style="position:relative">
                <label><strong>Linked Reps</strong></label>
                <a class="filterDone" v-if="fncCheckDone('linked_user')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="linkedSelect" @blur="fncCheckChange('linked_user')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterLinkedUser"  :items="quotesLiteFilters.linkedUser" @input="fncCheckDropdowns('linked_user')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <v-flex lg4 style="position:relative" v-if="objAuthorize.manufacturer == '16777962'">
                <label><strong>Location</strong></label>
                <a class="filterDone" v-if="fncCheckDone('location')" style="margin-top: 5px;" @click="fncLoadFilters()">Done</a>
                <v-select ref="locationSelect" @blur="fncCheckChange('location')" style="width: 90%;display:block;" class="dropdown dashDroprep" v-model="filterLocation"  :items="quotesLiteFilters.locations" @input="fncCheckDropdowns('location')"  item-value="id" item-text="name" autocomplete multiple single-line></v-select>
              </v-flex>
              <!--<v-flex lg4 style="position:relative">
                <label style="margin-bottom: 10px;"><strong>Customer Telephone</strong></label>
                <v-text-field ref="customerTelephone" @blur="fncCheckChange('customer_telephone')" v-model="filterCustomerTelephone" solo single-line></v-text-field>
              </v-flex>-->
            </v-flex>
          </v-layout>

        </v-navigation-drawer>

        <v-flex xs3>
        <v-text-field ref="searchField" prepend-icon="search" :label="fncQuoteSearchLabel()"  @input="CheckEditable" id="quoteSearch" :value="searchQuoteReport" solo single-line class="quoteNumberSearchPanel"></v-text-field>
          <v-btn class="dashGenerateRep qtGenerate clearSearch" @click="fncClearSearchTop()"><i class="material-icons">close</i></v-btn>
          <v-btn class="dashGenerateRep qtGenerate searchBtn" @click="fncSearchTop()">SEARCH</v-btn>

      </v-flex>
        <v-flex xs9 filterresetbtns>
          <v-btn disabled v-if="searchQuoteReport != '' || liteFilterLoaded == false" @click.prevent="filterDrawer = true" class="elevation-5" color="info"><i class="material-icons">filter_alt</i>Filters Loading</v-btn>
          <v-btn v-else @click.prevent="filterDrawer = true" class="elevation-5" color="info"><i class="material-icons">filter_alt</i>Filters</v-btn>
          <v-btn v-if="fncShowLiteFilters()" :disabled="searchQuoteReport != ''" @click.prevent="fncClearLiteFiltersSearch" class="elevation-5 clearFilters"><i class="material-icons">filter_alt</i>Clear Filters</v-btn>
        </v-flex>
        <v-flex xs12 datefilters>
          <!--<span style="font-size:12px; padding-top: 10px; float: left; width: 80px"><strong>Date Range:</strong></span>-->
          <date-picker @mousedown="fncClearFilterShadows" id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" @change="dateChange" v-model="reportStartDate" placeholder="Start Date" format="YYYY-MM-DD" lang="en" :not-after="disabledAfter" ></date-picker>
          <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep"><strong>to</strong></span>
          <date-picker @mousedown="fncClearFilterShadows" id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" @change="dateChange" v-model="reportEndDate" placeholder="End Date" format="YYYY-MM-DD" lang="en" :not-after="disabledAfter"></date-picker>
          <v-btn color="info" class="goDate" @click="fncSearchQuoteLiteClick()">GO</v-btn>
          <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep"><strong>OR</strong></span>        
          <v-select class="dropdown dashDroprep" @mousedown="fncClearFilterShadows" v-model="quoteFilter" :label="fncFilterLabel()" :items="dateOptions" @input="fncChangeDates()" item-value="id" item-text="name" autocomplete solo single-line></v-select>
        </v-flex>
        <v-flex xs3 columnbuttons >
          <v-btn @click.prevent="fncManageColumns()" class="elevation-5" color="info reloadButton"><i class="material-icons">view_column</i>Manage Columns</v-btn>
        </v-flex>
        <v-flex xs3 refreshbuttons>
          <v-btn @click.prevent="fncSearchNewQuotes" class="elevation-5" color="info reloadButton"><i class="material-icons">refresh</i>Refresh</v-btn>
        </v-flex>
        <v-flex xs3 downloadbuttons>
          <v-progress-circular v-show="excelLoading == true" indeterminate :width="20" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>
          <v-btn v-show="excelLoading == false" @click.prevent="fncExportQuotes" class="elevation-5 downloadButton"><i class="material-icons">download</i>Export</v-btn>
        </v-flex>
      </v-container>
      <v-container fluid style="clear: both;">
        <v-flex lg12 v-if="quoteLiteLoaded == false">
          <h2 style="padding-top: 10%;"><center>Loading Quotes<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
        </v-flex>
        <!--<p v-if="quoteLiteLoaded == true && quotesLite.length == 0"><strong>No matching records found.</strong></p>-->
        <!--<h4 style="margin-top: 60px" v-if="quotesLite.length == 0">No quotes could be found</h4>-->
        <!--<v-tabs v-if="quoteLiteLoaded == true && quotesLite.length != 0" v-model="activeTab" class="surveyTabs" slider-color="grey">-->
        <v-tabs v-if="quoteLiteLoaded == true" v-model="activeTab" class="surveyTabs" slider-color="grey">
          <v-tab class="tab" :disabled="fncCheckDisabledTab(tab, i)" :id="i" v-for="(tab, i) in quotesLite" @click="getTab(i, 'main')" :key="tabKeys[i]" v-if="i != 'count'" ripple>{{ fncFormatTabTitle(i, true) }}</v-tab>
          <v-tab-item v-for="(tab, n) in quotesLite" :key="i" :transition="false" :reverse-transition="false">
            <v-tabs v-model="activeTabSub" class="surveyTabs subTabs" slider-color="grey">
              <v-tab class="tab" :id="t" v-for="(t, z) in quotesLite[n]"  @click="getTab(z, 'sub')" v-if="i != 'count'" :key="tabKeys[t]" ripple>{{ fncFormatTabTitle(z, false) }}</v-tab>
              <v-tab-item style="padding-top: 0px !important;" class="pl-4 pr-4 pt-4 pb-4" v-for="(a, b) in quotesLite[n]" :key="z" :transition="false" :reverse-transition="false">
              </v-tab-item>
            </v-tabs>
          </v-tab-item>
        </v-tabs>
        <v-data-table v-if="quoteLiteLoaded == true" no-data-text="No matching records found." :items="fncGetTabItems()" loading="true" :headers="headers" ref="sortableTable" :search="searchQuoteReport" class="elevation-1 quoteTable"  :rows-per-page-items="[20,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows">
              <td><div class="flex-buttons">
                <a @click="fncFullQuote(props.item)" class="quoteDetailsBtn">Quote Details</a>
                <a v-if="props.item.hasAttachment != null && props.item.hasAttachment != '' && props.item.hasAttachment != 'null'" @click.prevent="fncQuoteSettings(props.item.id, props.item.quote_no, props.item)" class="reportAttachment"><i class="material-icons attachmentTick">done</i><i class="material-icons paperclip">attach_file</i></a>
                <a v-else @click.prevent="fncQuoteSettings(props.item.id, props.item.quote_no, props.item)" class="reportAttachment"><i style="opacity: 1" class="material-icons paperclip">attach_file</i></a>
                <a class="menu editQuoteIcon" title="Edit Quote" v-if="props.item.hide_quote_edit == true" @click="fncEditQuote(props.item)"></a>
                <a class="menu openCalcIcon" title="Open Calculators" v-if="objAuthorize.manufacturer == '385889803' && props.item.price == '0' && props.item.calculator_links != '' && props.item.calculator_links != 'null' && props.item.calculator_links != null" @click.prevent="fncOpenCalculator(props.item)"></a>
              </div></td>
              <td v-for="item in liteColumns" v-if="item.checked != false && item.text != ''">
                <span v-if="item.id == 'store'" class="storeColumn" v-html="fncHighlightSearchText(props.item.branch)"></span>
                <span v-if="item.id == 'service_type'" v-html="fncHighlightSearchText(fncGetType('service_type', props.item.service_type))"></span>
                <span v-if="item.id == 'quote_type'" v-html="fncHighlightSearchText(props.item.type)"></span>
                <div v-if="item.id == 'quote_no'"><span class="quoteNumber" v-html="fncHighlightSearchText(props.item.quote_no)"></span><br /><span v-html="fncHighlightSearchText(props.item.created)"></span></div>
                <span v-if="item.id == 'department'" v-html="fncHighlightSearchText(props.item.department)"></span>
                <!--<span v-if="item.id == 'rep_name'">{{ props.item.repName }} - {{ props.item.repSurname }}</span>-->
                <span v-if="item.id == 'customer_name'" v-html="fncHighlightSearchText(fncTextValue(props.item.name) + ' - ' + fncTextValue(props.item.surname))"></span>
                <span v-if="item.id == 'external_ref'" v-html="fncHighlightSearchText(props.item.external_ref)"></span>
                <span v-if="item.id == 'grant_total'" v-html="fncHighlightSearchText('R' + props.item.grand_total.toFixed(2))"></span>

                <div class="kamColumn" v-if="item.id == 'kam'">
                  <span v-html="fncHighlightSearchText(props.item.kam_string)"></span>
                  <v-btn v-if="item.id == 'kam' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1" @click="fncSetResponsibleUsers( props.item, 'kam' )" slot="activator" class="elevation-5" color="info">SET</v-btn>
                  <span v-else>-</span>
                </div>

                <div class="kamColumn" v-if="item.id == 'coordinator'">
                  <span v-html="fncHighlightSearchText(props.item.coordinator_string)"></span>
                  <v-btn v-if="item.id == 'coordinator' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1" @click="fncSetResponsibleUsers( props.item, 'coordinator' )" slot="activator" class="elevation-5" color="info">SET</v-btn>
                  <span v-else>-</span>
                </div>

                <div class="kamColumn" v-if="item.id == 'designer'">
                  <span v-html="fncHighlightSearchText(props.item.designer_string)"></span>
                  <v-btn v-if="item.id == 'designer' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1" @click="fncSetResponsibleUsers( props.item, 'designer' )" slot="activator" class="elevation-5" color="info">SET</v-btn>
                  <span v-else>-</span>
                </div>


                <div style="display: flex; align-items: center" v-if="item.id == 'status'" class="statusColumn">
                  <span :id="fncSetId(props.item.id)" class="statusText" v-html="fncHighlightSearchText(props.item.status)"></span>
                  <span v-if="objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1"  @click="fncEditStatusPopup(props.item)"><v-btn class="elevation-5" color="info">UPDATE STATUS</v-btn></span>
                  <a href="#" @click.prevent="fncViewStatusHistory(props.item)"><i class="material-icons">history</i></a>
                </div>



                <span v-if="item.id == 'vendor_recipient'" class="nowrap vendorRecipient">
                          <span v-if="props.item.vendor_recipient != ''" v-html="fncHighlightSearchText(fncDotDotDot(props.item.vendor_recipient))"></span>
                          <span v-else v-html="fncHighlightSearchText('Not Set')"></span>
                          <v-btn class="elevation-5" @click="fncEditVendorRecipient(props.item)" color="info">UPDATE</v-btn>
                        </span>


                <span v-if=" item.id == 'customer_recipient'" class="nowrap customerRecipient">
                          <span v-if="props.item.customer_recipient != ''" v-html="fncHighlightSearchText(fncDotDotDot(props.item.customer_recipient))"></span>
                          <span v-else v-html="fncHighlightSearchText('Not Set')"></span>
                          <v-btn class="elevation-5" @click="fncEditCustomerRecipient(props.item)" color="info">UPDATE</v-btn>
                        </span>
                <span v-if="item.id == 'customer_email'" v-html="fncHighlightSearchText(props.item.customer_email)"></span>
                <span v-if="item.id == 'customer_tel'" v-html="fncHighlightSearchText(props.item.customer_telephone)"></span>
                <span v-if="item.id == 'quote_type'" v-html="fncHighlightSearchText(props.item.quote_type)"></span>
                <span v-if="item.id == 'originator_name'" v-html="fncHighlightSearchText(fncTextValue(props.item.repName) + ' ' + fncTextValue(props.item.repSurname))"></span>
                <div v-if=" item.id == 'manufacturer_date'" class="nowrap dateInstallation">

                  <date-picker style="min-width: 120px !important;"   @change="handleChange($event, props.item, 'manufacturer')"  valueType="format"
                               v-model="props.item.manufacturer_date_api"   class="quoteDateRep dashDateRep" format="YYYY-MM-DD"  :minute-step="01" placeholder="Manufacturer Date"  lang="en" >
                  </date-picker>

                  <span>
                            <a  href="#" @click.prevent="fncShowDateHistory(props.item,'manufacturer_date_change')"><i class="material-icons">history</i></a>
                          </span>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-content>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import tableDragger from 'table-dragger';
  import Modal from '@/components/shared/modal';
  import DatePicker from 'vue2-datepicker'
  import router from '@/router';
  import {setObjAuthorize} from "../../../store/mutations";
  import {commercialKams} from "../../../store/modules/processes/getters";

  export default {
    name: 'QuoteList',
    data () {
      return {
        disabledAfter: '',
        activeTab: '0',
        activeTabSub: '0',
        tabKeys: [],
        sortedQuotes: [],
        sortKey: 'quote_date',
        stKey: 'status',
        sortOrders: {
          'quote_date': 1, // 1 for ascending, -1 for descending
          'status': 1,
        },
        isStatusSortOn: false,
        isDateSortOn: false,
        sortStatus: 1,
        dateChanged: false,
        hasScroll: true,
        drawer: false,
        InputValueSearch: null,
        EnableSearch: false,
        InputValueSearchQuote: null,
        EnableSearchQuote:  window.localStorage.reportSearch !== undefined && window.localStorage.reportSearch !== '' ? true: false ,
        shortcuts: [
          {
            text: 'Today',
            onClick: () => {
              //this.time3 = [ new Date(), new Date() ]
              alert('test');
            }
          }
        ],
        tabs_to_display: [],
        more:[],
        chageTopreviousTab: false,
        previousTab: '',
        topTab:'',
        secondTab: window.localStorage.secondTab !== undefined && window.localStorage.secondTab != null ?  window.localStorage.secondTab  : null,
        filterStatusSet: [],
        quoteFilter: window.localStorage.quoteSetDays !== undefined && window.localStorage.quoteSetDays != null ?  window.localStorage.quoteSetDays  : null,
        //quoteFilter: '',
        //quoteFilter: quoteSetDays,
        filterDrawer: false,
        headerLoaded: false,
        //search: window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' ? '' : window.localStorage.reportSearch,
        search: '',
        searchQuoteReport: window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' ? '' : window.localStorage.reportSearch,
        searchQuoteHighlight: window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' ? '' : window.localStorage.reportSearch,
        newSearch: '',
        headers: [
          { text: '', value: '', sortable: false, width: '15%'  },
          { text: 'QUOTE NUMBER', value: 'quote_no', sortable: false, width: '15%'  },
          { text: 'STORE', value: 'branch', sortable: false, width: '10%'  },
          { text: 'DEPARTMENT', value: 'department', sortable: false, width: '10%'  },
          { text: 'CUSTOMER', value: 'name', sortable: false, width: '15%'  },
          { text: 'STATUS', value: 'status', sortable: false, width: '20%'  },
        ],
        columnLengths: [],
        objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
        objOriginator: window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null ? JSON.parse(window.localStorage.reportOriginators) : ['all'],
        objKam: window.localStorage.reportKams != undefined && window.localStorage.reportKams != null ? JSON.parse(window.localStorage.reportKams) : ['all'],
        objcOriginator: window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null ? JSON.parse(window.localStorage.reportcOriginator) : ['all'],
        objQuoteType: window.localStorage.reportQuoteType != undefined && window.localStorage.reportQuoteType != null ? JSON.parse(window.localStorage.reportQuoteType) : ['all'],
        objServiceType: window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null ? JSON.parse(window.localStorage.reportServiceType) : ['all'],
        objProjects: window.localStorage.reportProjects != undefined && window.localStorage.reportProjects != null ? JSON.parse(window.localStorage.reportProjects) : ['all'],
        objCompany: window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null ? JSON.parse(window.localStorage.reportCompany) : ['all'],
        objStatus: window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null ? JSON.parse(window.localStorage.reportStatus) : ['all'],
        objCustomerCompany: window.localStorage.reportCompanies != undefined && window.localStorage.reportCompanies != null ? JSON.parse(window.localStorage.reportCompanies) : ['all'],
        objCustomerUser: window.localStorage.reportUsers != undefined && window.localStorage.reportUsers != null ? JSON.parse(window.localStorage.reportUsers) : ['all'],
        objProject: window.localStorage.reportProject != undefined && window.localStorage.reportProject != null ? JSON.parse(window.localStorage.reportProject) : ['all'],
        objSpecifier: window.localStorage.reportSpecifiers != undefined && window.localStorage.reportSpecifiers != null ? JSON.parse(window.localStorage.reportSpecifiers) : ['all'],
        objVendor: window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null ? JSON.parse(window.localStorage.reportVendors) : ['all'],
        objDepartment: window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null ? JSON.parse(window.localStorage.reportDepartments) : ['all'],
        objStore: window.localStorage.reportStores != undefined && window.localStorage.reportStores != null ? JSON.parse(window.localStorage.reportStores) : ['all'],
        reportStartDate: window.localStorage.reportStartDate != undefined && window.localStorage.reportStartDate != null ? window.localStorage.reportStartDate : '',
        reportEndDate: window.localStorage.reportEndDate != undefined && window.localStorage.reportEndDate != null ? window.localStorage.reportEndDate : '',
        startDate: window.localStorage.qStartDate,
        endDate: window.localStorage.qEndDate,
        tableWidth: 300,
        reportDate: window.localStorage.reportDates != undefined && window.localStorage.reportDates != null ? this.setDates() : '',
        lang: {
          placeholder: {
            date: 'Select Date',
            dateRange: 'Select Date'
          }
        },
        filterActive: this.$route.query.filter != null ? true : false,
        originatorBlur: false,
        companyBlur: false,
        customerBlur: false,
        statusBlur: false,
        specifierBlur: false,
        projectBlur: false,
        vendorBlur: false,
        departmentBlur: false,
        storeBlur: false,
        hasFilters: false,
        hasFiltersDateOnly: false,
        storeMapping: [],
        dateOptions: [
          { id: 1, name: 'View All Quotes' },
          { id: 2, name: 'View Last 6 Months' },
          { id: 3, name: 'View Last 90 Days' },
          { id: 4, name: 'View Last 60 Days' },
          { id: 5, name: 'View Last 30 Days' },
          { id: 6, name: 'View Last Week' }
        ],
        nonClickable: true,
        storeMapping: [],
        quotesLinked: false,
        pagination: {},
        page: 1,
        regenFalse: true,
        dateFilterShow: false,
        vendorFilterShow: false,
        departmentFilterShow: false,
        storeFilterShow: false,
        originatorFilterShow: false,
        customerFilterShow: false,
        statusFilterShow: false,
        repFilterShow: false,
        regionFilterShow: false,
        showVendorClose: false,
        getPage: 1,
        totalPages: 1,
        hideOriginatorLabels: false,
        filteredRepsDropdown: [],
        canEditOriginator: false,
        quotesStatuses: [],
        vendorUserList: [],
        objRegion: window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null ? JSON.parse(window.localStorage.reportRegions) : ['all'],
        objRep: window.localStorage.reportReps != undefined && window.localStorage.reportReps != null ? JSON.parse(window.localStorage.reportReps) : ['all'],
        selectedStatus: null,
        checkoutStatus: 0,
        filterStatus: window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null ? JSON.parse(window.localStorage.reportStatus) : ['all'],
        filterDepartment: window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null ? JSON.parse(window.localStorage.reportDepartments) : ['all'],
        filterStore: window.localStorage.reportStores != undefined && window.localStorage.reportStores != null ? JSON.parse(window.localStorage.reportStores) : ['all'],
        filterCustomer: window.localStorage.reportCustomer != undefined && window.localStorage.reportCustomer != null ? JSON.parse(window.localStorage.reportCustomer) : ['all'],
        filterVendor: window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null ? JSON.parse(window.localStorage.reportVendors) : ['all'],
        filterCompany: window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null ? JSON.parse(window.localStorage.reportCompany) : ['all'],
        filterOriginator: window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null ? JSON.parse(window.localStorage.reportOriginators) : ['all'],
        filterProject: window.localStorage.reportProject != undefined && window.localStorage.reportProject != null ? JSON.parse(window.localStorage.reportProject) : ['all'],
        filterServiceType: window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null ? JSON.parse(window.localStorage.reportServiceType) : ['all'],
        filterLinkedUser: window.localStorage.reportLinked != undefined && window.localStorage.reportLinked != null ? JSON.parse(window.localStorage.reportLinked) : ['all'],
        filterLocation: window.localStorage.reportLocation != undefined && window.localStorage.reportLocation != null ? JSON.parse(window.localStorage.reportLocation) : ['all'],
        filterCustomerTelephone: window.localStorage.reportCustomerTelephone != undefined && window.localStorage.reportCustomerTelephone != null ? window.localStorage.reportCustomerTelephone : '',
        liteMainTab: window.localStorage.liteMainTab != undefined && window.localStorage.liteMainTab != null ? window.localStorage.liteMainTab : '',
        liteSubTab: window.localStorage.liteSubTab != undefined && window.localStorage.liteSubTab != null ? window.localStorage.liteSubTab : ''
      }
    },
    methods: {
      fncTextValue( value ) {
        return value == undefined || value == null ? '' : value;
      },
      fncEscapeHtml( value ) {
        return String(this.fncTextValue(value))
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      },
      fncEscapeRegExp( value ) {
        return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },
      fncHighlightSearchText( value ) {
        var text = String(this.fncTextValue(value));
        var search = String(this.fncTextValue(this.searchQuoteHighlight)).trim();

        if( search == '' ) {
          return this.fncEscapeHtml(text);
        }

        var regex = new RegExp(this.fncEscapeRegExp(search), 'gi');
        var highlightedText = '';
        var lastIndex = 0;
        var match;

        while( (match = regex.exec(text)) !== null ) {
          highlightedText += this.fncEscapeHtml(text.slice(lastIndex, match.index));
          highlightedText += '<span class="quoteSearchHighlight">' + this.fncEscapeHtml(match[0]) + '</span>';
          lastIndex = match.index + match[0].length;
        }

        highlightedText += this.fncEscapeHtml(text.slice(lastIndex));

        return highlightedText;
      },
      fncGetTabItems() {

        if( this.searchQuoteReport != undefined && this.searchQuoteReport != '' ) {

          return this.quotesLite['quotes']['Search For: ' + this.searchQuoteReport];

        } else {
          if( this.liteMainTab == undefined || this.liteMainTab == '' ) {
            this.liteMainTab = 'all';
          }
          if( this.liteSubTab == undefined || this.liteSubTab == '' ) {
            this.liteSubTab = 'all';
          }
        }

        return this.quotesLite[this.liteMainTab][this.liteSubTab];
      },
      fncShowLiteFilters() {

        if(
          this.filterStatus.indexOf('all') != -1 &&
          this.filterDepartment.indexOf('all') != -1 &&
          this.filterStore.indexOf('all') != -1 &&
          this.filterCustomer.indexOf('all') != -1 &&
          this.filterVendor.indexOf('all') != -1 &&
          this.filterCompany.indexOf('all') != -1 &&
          this.filterOriginator.indexOf('all') != -1 &&
          this.filterProject.indexOf('all') != -1 &&
          this.filterServiceType.indexOf('all') != -1 &&
          this.filterLinkedUser.indexOf('all') != -1 &&
          this.filterLocation.indexOf('all') != -1
        ){
          return false;
        }

        return true;
      },
      fncCheckDisabledTab( tab, increment ) {

        if( tab.length == 'undefined' || tab.length == undefined ) {
          return false;
        }

        return true;

      },
      fncSetResponsibleUsers( quote, type ) {
        var modalDetails = { title: 'Quote Reps (' + quote.quote_no + ')', component: 'modal-set-reps-lite', mstate: true, params: { object: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncShowDateHistory(objItem, type)
      {
        this.$store.dispatch({
          type: 'fncGetDateHistory',
          id: objItem.id,
          history_type: type
        });

        let modalDetails = { title: 'Installation Date History (' + objItem.quote_no + ')', component: 'modal-date-history', mstate: true, params: {id:objItem.id, history_type: type } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      handleChange(event, objItem, type)
      {

        let dateObj = event
        let se = null

        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');

        if (type === 'manufacturer'){
          se = `${year}-${month}-${day}`;
        }
        else if(type === 'delivery_date_api'){
          se = `${year}-${month}-${day}`;
          this.convertedItems[objItem.id] = se
        }
        else{
          se = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          this.dates[objItem.id] = se
        }

// Set the time components to 0 to represent only the date quoteList




        this.$store.dispatch({
          type: 'fncUpdateDate',
          date: se,
          quote_no: objItem.id,
          type_action: type
        })
        this.$forceUpdate();

      },
      fncEditVendorRecipient( quote ) {

        var modalDetails = { title: 'Update Vendor Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'vendor', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncEditCustomerRecipient( quote ) {

        var modalDetails = { title: 'Update Customer Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'customer', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncGetType( type, value ) {

        if( type == 'service_type' ) {
          if( value == '3' ) {
            return 'Commercial';
          } else if( value == '1' ) {
            return 'Assisted Service';
          } else if( value == '2' ) {
            return 'Self Service';
          } else {
            return 'Unknown';
          }
        }

      },
      fncManageColumns() {
        var modalDetails = { title: 'Manage Columns', component: 'modal-filter-columns-lite', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncChangeLead( item ) {

        this.$store.dispatch({
          type: 'fncUpdateLead',
          id: item.id,
          lead: item.is_lead
        })

      },
      fncShowDropdown() {
        console.log('Figaro');
        console.log( this.$refs['statusSelect'] );
        /*document.getElementsByClassName('statusClick')[0].click();*/
        /*this.$refs['statusSelect'].focus();
        this.$refs['statusSelect'].activateMenu();
        this.$refs['statusSelect'].click();
        this.$refs['statusSelect'].activate();*/
      },
      fncToggleAll( type ) {
        if( type == 'status' ) {
          /*if( this.filterStatus.length == 0 ) {
            for( var x in this.quotesLiteFilters.status ) {
              this.filterStatus.push(this.quotesLiteFilters.status[x].id);
            }
          } else if( this.filterStatus.length != this.quotesLiteFilters.status.length ) {
            this.filterStatus = [];
            for( var x in this.quotesLiteFilters.status ) {
              this.filterStatus.push(this.quotesLiteFilters.status[x].id);
            }
          } else {
            this.filterStatus = [];
          }*/
          /*console.log('Refs');
          console.log( this.$refs );
          this.$refs.statusSelect.click();*/
        }
      },
      fncOpenCalculator(quoteItem) {
        this.$store.dispatch('fncGetCalculators', quoteItem);
      },
      fncQuoteSettings(quoteId, quoteNo,item) {
        this.$store.dispatch({
          type: 'fncQuoteSettings',
          quoteId: quoteId,
          quoteNo: quoteNo,
          data:item,
        })
      },
      fncExportQuotes() {

        this.$store.commit('fncExcelLoading', true);
        /*this.$store.dispatch({
          type: 'fncDoQuoteReportExcel',
          status: this.filterStatus,
          department: this.filterDepartment,
          store: this.filterStore,
          customer: this.filterCustomer,
          vendor: this.filterVendor,
          company: this.filterCompany,
          originator: this.filterOriginator,
          project: this.filterProject,
          service_type: this.filterServiceType,
          start_date: this.reportStartDate,
          end_date: this.reportEndDate
        })*/

        // now we need to run the data as well
        var dToday = new Date();
        var startDate = this.reportStartDate;

        if( startDate == '' ) {

          var newStartDate = new Date(new Date().setDate(dToday.getDate() - 30));
          startDate = newStartDate.toISOString().split('T')[0];

          this.reportStartDate = startDate;
          localStorage.setItem('reportStartDate', this.reportStartDate);

        }

        var endDate = this.reportEndDate;

        if( endDate == '' ) {
          endDate = dToday.toISOString().split('T')[0];

          this.reportEndDate = endDate;
          localStorage.setItem('reportEndDate', this.reportEndDate);
        }

        if( this.reportStartDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( this.reportEndDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        this.$store.dispatch({
          'type': 'fncQuoteReportLiteExcel',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': startDate,
          'endDate': endDate,
          'vendor': this.filterVendor,
          'company': this.filterCompany,
          'originator': this.filterOriginator,
          'project': this.filterProject,
          'service_type': this.filterServiceType,
          'linked_user': this.filterLinkedUser,
          'location': this.filterLocation,
          'customer_telephone': this.filterCustomerTelephone
        });
      },
      fncViewStatusHistory( item ) {
        this.$store.dispatch('fncGetQuoteHistory', item.id);
        var modalDetails = { title: 'Status History (' + item.quote_no + ')', component: 'modal-quote-history', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSearchQuoteLiteClick() {

        this.$store.commit('fncSetQuoteLiteLoaded', false);

        var startDate = JSON.stringify(this.reportStartDate);

        var endDate = JSON.stringify(this.reportEndDate);

        if( startDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( endDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        localStorage.setItem('reportStartDate', startDate);
        localStorage.setItem('reportEndDate', endDate);

        window.location.reload();

        /*this.$store.dispatch({
          'type': 'fncQuoteReportLite',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': startDate,
          'endDate': endDate,
          'vendor': this.filterVendor,
          'company':this.filterCompany,
          'originator':this.filterOriginator,
          'project': this.filterProject,
          'service_type': this.filterServiceType
        });*/
      },
      fncSearchQuoteLite() {

        localStorage.setItem('liteMainTab', 'all');
        localStorage.setItem('liteSubTab', 'all');

        this.$store.commit('fncSetQuoteLiteLoaded', false);
        this.filterDrawer = false;

        var startDate = this.reportStartDate;
        var endDate = this.reportEndDate;
        if( this.reportStartDate && this.reportStartDate != '' && this.reportStartDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( this.reportEndDate && this.reportEndDate != '' && this.reportEndDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        if (this.filterOriginator != '' ) {
          localStorage.setItem('reportOriginators', JSON.stringify(this.filterOriginator));
        } else {
          localStorage.removeItem('reportOriginators');
        }

        if (this.filterStatus != '') {
          localStorage.setItem('reportStatus', JSON.stringify(this.filterStatus));
          this.secondTab = null
        }
        else {
          localStorage.removeItem('reportStatus');
        }

        if (this.filterServiceType != '' ) {
          localStorage.setItem('reportServiceType', JSON.stringify(this.filterServiceType));
        } else {
          localStorage.removeItem('reportServiceType');
        }

        if (this.filterVendor != '' ) {
          localStorage.setItem('reportVendors', JSON.stringify(this.filterVendor));
        } else {
          localStorage.removeItem('reportVendors');
        }

        if (this.filterDepartment != '' ) {
          localStorage.setItem('reportDepartments', JSON.stringify(this.filterDepartment));
        } else {
          localStorage.removeItem('reportDepartments');
        }

        if (this.filterStore != '' ) {
          localStorage.setItem('reportStores', JSON.stringify(this.filterStore));
        } else {
          localStorage.removeItem('reportStores');
        }

        if (this.filterProject != '') {
          localStorage.setItem('reportProjects', JSON.stringify(this.filterProject));
        } else {
          localStorage.removeItem('reportProjects');
        }

        if (this.filterCustomer != '') {
          localStorage.setItem('reportCustomer', JSON.stringify(this.filterCustomer));
        } else {
          localStorage.removeItem('reportCustomer');
        }

        if (this.filterCompany != '') {
          localStorage.setItem('reportCompany', JSON.stringify(this.filterCompany));
        } else {
          localStorage.removeItem('reportCompany');
        }

        if (this.filterLocation != '') {
          localStorage.setItem('reportLocation', JSON.stringify(this.filterLocation));
        } else {
          localStorage.removeItem('reportLocation');
        }

        if (this.filterLinkedUser != '') {
          localStorage.setItem('reportLinked', JSON.stringify(this.filterLinkedUser));
        } else {
          localStorage.removeItem('reportLinked');
        }

        if (this.filterCustomerTelephone != '') {
          localStorage.setItem('reportCustomerTelephone', this.filterCustomerTelephone);
        } else {
          localStorage.removeItem('reportCustomerTelephone');
        }



        localStorage.setItem('reportStartDate', this.reportStartDate);
        localStorage.setItem('reportEndDate', this.reportEndDate);

        window.location.reload();
        /*this.$store.dispatch({
          'type': 'fncQuoteReportLite',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': startDate,
          'endDate': endDate,
          'vendor': this.filterVendor,
          'company': this.filterCompany,
          'originator': this.filterOriginator,
          'project': this.filterProject,
          'service_type': this.filterServiceType
        });*/

      },
      fncChangeDates() {

        var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];
        // localStorage.getItem('reportDates');
        switch(this.quoteFilter) {
          case 1:
            this.reportStartDate = '';
            this.reportEndDate = dateToday;
            break;
          case 2:
            var d = new Date();
            d.setMonth(d.getMonth() - 6);
            var startDate = d.toISOString().split('T')[0];
            break;
          case 3:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 4:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 5:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 6:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
            startDate = startDate.toISOString().split('T')[0];
            break;
        }

        this.reportDate = [];

        if( startDate != '1900-01-01' ) {
          this.reportStartDate = startDate;
          this.reportEndDate = dateToday ;
        }

        localStorage.setItem('quoteSetDays', this.quoteFilter);

        this.fncSearchQuoteLite();

      },
      fncSearchTop() {
        localStorage.setItem('reportSearch',this.$refs.searchField.lazyValue);

        window.location.reload();

        /*this.$store.dispatch('fncQuoteReportLite');
        this.$store.dispatch('fncQuoteReportLiteFilters');*/

      },
      fncClearLiteFiltersSearch() {
        this.filterStatus = ['all'];
        this.filterDepartment = ['all'];
        this.filterStore = ['all'];
        this.filterCustomer = ['all'];
        this.filterVendor = ['all'];
        this.filterCompany = ['all'];
        this.filterOriginator = ['all'];
        this.filterProject = ['all'];
        this.filterServiceType = ['all'];
        this.filterLinkedUser = ['all'];
        this.filterLocation = ['all'];
        this.filterCustomerTelephone = '';

        this.fncSearchQuoteLite();
      },
      fncClearLiteFilters() {

        this.filterStatus = ['all'];
        this.filterDepartment = ['all'];
        this.filterStore = ['all'];
        this.filterCustomer = ['all'];
        this.filterVendor = ['all'];
        this.filterCompany = ['all'];
        this.filterOriginator = ['all'];
        this.filterProject = ['all'];
        this.filterServiceType = ['all'];
        this.filterLinkedUser = ['all'];
        this.filterLocation = ['all'];
        this.filterCustomerTelephone = '';

        this.fncLoadFilters();
      },
      fncLoadFilters() {

        this.$store.commit('fncSetFiltersLoading', true);

        var startDate = this.reportStartDate;
        var endDate = this.reportEndDate;
        if( this.reportStartDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( this.reportEndDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        this.$store.dispatch({
          'type': 'getQuotesLiteFilters',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': startDate,
          'endDate': endDate,
          'vendor': this.filterVendor,
          'company': this.filterCompany,
          'originator': this.filterOriginator,
          'project': this.filterProject,
          'service_type': this.filterServiceType,
          'linked_user': this.filterLinkedUser,
          'location': this.filterLocation,
          'customer_telephone': this.filterCustomerTelephone
        });

        /*this.$store.dispatch({
          'type': 'fncQuoteReportLiteFilters',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'vendor': this.filterVendor
        })*/
      },
      /*fncSearchQuoteLite() {

        var statusStorage = JSON.stringify( this.filterStatus );
        localStorage.setItem('reportStatus', statusStorage);

        var departmentStorage = JSON.stringify( this.filterDepartment )
        localStorage.setItem('reportDepartment', departmentStorage);

        var storeStorage = JSON.stringify( this.filterStore );
        localStorage.setItem('reportStore', storeStorage);

        var customerStorage = JSON.stringify( this.filterCustomer );
        localStorage.setItem('reportCustomer', customerStorage);

        var vendorStorage = JSON.stringify( this.filterVendor );
        localStorage.setItem('reportVendor', vendorStorage);

        localStorage.setItem('reportStartDate', this.reportStartDate);
        localStorage.setItem('reportEndDate', this.reportEndDate);

        this.$store.dispatch({
          'type': 'fncQuoteReportLite',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': this.reportStartDate,
          'endDate': this.reportEndDate,
          'vendor': this.filterVendor
        })

        this.$store.dispatch({
          'type': 'getQuotesLiteFilters',
          'status': this.filterStatus,
          'department': this.filterDepartment,
          'store': this.filterStore,
          'customer': this.filterCustomer,
          'startDate': this.reportStartDate,
          'endDate': this.reportEndDate,
          'vendor': this.filterVendor
        });

        this.filterDrawer = false;
      },*/
      fncFullQuote( item ) {

        this.$store.commit('fncSetQuoteLiteContentLoaded', false);

        this.$router.replace('/quote-single-content?quote=' + item.id);

        /*var url = window.location.protocol + process.env.API_ENDPOINT;
            url = url.replace('/Handlers','');
            url = url + '#/quote-single-content?quote=' + item.id;*/

        // window.open(url);
        /*window.location = url;



        //this.$router.push({path: '/quote-single-content?quote=' + item.id});
        // this.$router.go();

        /*this.$store.commit('fncSetQuoteLiteContentClick', true);
        this.$store.dispatch('fncFullContent', item);*/

        /*var modalDetails = { title: 'Quote Details ( ' + item.quote_no + ' )', component: 'modal-full-quote', mstate: true };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });*/

      },
      fncFormatTabTitle( title, showAll ) {

        if( title == 'all' && showAll == true ) {
          return 'Most Recent';
        }

        if( title == 'all' && showAll == false ) {
          return 'All';
        }

        if( typeof title == 'number'  ) {
          return '';
        }

        title = title.replace('is_', '');
        return title.replaceAll('_', ' ');

      },
      fncUpdateStore( item ) {

        var modalDetails = { title: 'Update Store (' + item.quote_no + ')', component: 'modal-update-store', mstate: true, params: { quote: item } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      toggleSign(number) {
        if (number >= 0) {
          return -number;
        } else {
          return Math.abs(number);
        }
      },
      sortBy(type){
        if (this.sortOrders.quote_date ==  1){
          this.sortOrders.quote_date = -1
        }
        else
          this.sortOrders.quote_date = 1

        // sortedQuotes() {
        const order = this.sortOrders[this.sortKey] || 1;
        const quotes = this.quoteSearchList.slice();
        quotes.sort((a, b) => {
          const aVal = new Date(a[this.sortKey]).getTime();
          const bVal = new Date(b[this.sortKey]).getTime();
          return (aVal - bVal) * order;
        });

        this.isDateSortOn = true
        this.isStatusSortOn = false

        this.$store.commit('fncSortedQuotes', quotes);

      },
      sortByStatus() {
        const quot = this.quoteSearchList.map(obj => obj.id);
        this.sortStatus = this.toggleSign(this.sortStatus)
        const order = this.sortStatus
        this.isStatusSortOn = true
        this.isDateSortOn = false

        this.$store.dispatch({
          type: 'fncGetStatusOrder',
          quotes: quot,
          order: order
        });
      },
      fncStoreAudits( quote ) {
        var modalDetails = { title: 'Store Code Audits (' + quote.quote_no + ')', component: 'modal-store-audit', mstate: true, params: { quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncRunQuoteSearch() {
        setTimeout(function(){
          window.location.reload();
        }, 250)
      },
      fncRefreshQuoteNo( item ) {

        this.$store.dispatch('fncUpdateQuoteNumber', item.id);

      },
      fncCheckCalcItems( item ) {

        /*console.log( item );

        var canDepartmentEdit = this.fncDepartmentCanEdit(item);

        if( canDepartmentEdit == false ) {

          if( item.pricing_total == '0' || item.pricing_total == '0.00' ) {
            return true;
          } else {
            return false;
          }

        } else {
          return true;
        }*/

        if( item.pricing_total == '0' || item.pricing_total == '0.00' ) {
          if( this.surveyList[item.id] != 'undefined' && this.surveyList[item.id] != undefined && this.surveyCalculators[this.surveyListProcess[item.id]] != undefined ) {
            return true;

          }
        }

        return false;

      },
      fncDepartmentCanEdit( item ) {

        for( var d in this.departmentList ) {
          if( this.departmentList[d].id == item.departmentId ) {
            if( this.departmentList[d].hide_quote_edit == '1' || this.departmentList[d].hide_quote_edit == 1 ) {
              for( var s in this.statusList ) {
                if( this.statusList[s].description == item.status ) {
                  if( this.statusList[s].order < this.checkoutStatus ){
                    return true;
                  }
                }
              }
            }
          }
        }

        return false;
      },
      dateChange(){
        this.dateChanged = true;  
        this.quoteFilter = '';
        localStorage.setItem('quoteSetDays', '');           
      },
      onTabSelected(index) {
        this.secondTab = index
        localStorage.setItem('secondTab', index);
      },
      tabIsDisabled(key){
        let index
        switch (key) {
          case 'is_initial_engagement_quote' :
            index = '0'
            break
          case 'is_negotiating_customer_approval' :
            index = '1'
            break
          case 'is_manufacturer_fulfilment' :
            index = '2'
            break
          case 'is_cancelled_expired_rejected' :
            index = '3'
            break
        }

        if (index === this.topTab){
          return false
        }
        else{
          if (this.tabs.length !==  0){
            return Object.keys(this.tabs[key]).length === 0
          }
          else
            return true
        }

      },
      onResize(key){
        const temp = this.tabs[key].slice()
        this.tabs_to_display = temp.splice(0, (window.innerWidth/100)-1)
        this.more = temp.splice(0)
        console.log('more', this.more)
      },
      fncCanApplyLeftBorder(key, description){ // is first
        if (Array.isArray(this.tabs[key]) && this.tabs[key].length > 1){
          let firstElement = this.tabs[key][0].description
          if (description === firstElement)
            return true
          else
            return  false
        }
        else{
          let firstKey = Object.keys(this.tabs[key])[0]
          if (firstKey)
            return (this.tabs[key][firstKey].description === description) ? true: false
        }

      },
      fncCanApplyRightBorder(key, description){
        if (Array.isArray(this.tabs[key]) && this.tabs[key].length > 1){
          let last = this.tabs[key].length
          let lastElement = this.tabs[key][last-1].description
          return (description === lastElement) ? true : false
        }else
        {
          //object
          let lastItem = Object.values(this.tabs[key]).pop();
          if (lastItem )
            return (description === lastItem.description) ? true : false
        }

      },
      fncShowSummaryReporting() {
        var modalDetails = { title: 'Summary Reporting', component: 'modal-summary-reporting', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      CheckEditableSearch(event){ console.log('CheckEditableSearch '+ event)
        if(event != null && event !== '' ){
            this.EnableSearchQuote = true
          }
        else if ( window.localStorage.reportSearch != null && window.localStorage.reportSearch !== undefined && window.localStorage.reportSearch !== '')
        {
          this.EnableSearchQuote = true
        }
        else
          this.EnableSearchQuote = false
      },
      CheckEditable(event){
          this.searchQuoteHighlight = event;
          const myObject = JSON.parse(localStorage.getItem('reportSearchQuote'));

          if(event != null && event !== '' ){
            this.EnableSearch = true
          }
          else if( myObject )
            this.EnableSearch = true
          else
            this.EnableSearch = false
      },
      fncSetId( id ) {
        return id;
      },
      fncDotDotDot( str ) {
        if( str.length > 30 ) {
          return str.substr(0,30) + ' ...';
        }
        return str;
      },
      fncEditVendorRecipient( quote ) {

        var modalDetails = { title: 'Update Vendor Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'vendor', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncEditCustomerRecipient( quote ) {

        var modalDetails = { title: 'Update Customer Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'customer', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncShowVendorUsers( vendorName, quote ) {

          var vendorUsers = [];
          if( this.vendorUserList[vendorName] != null ) {
            vendorUsers = this.vendorUserList[vendorName];
          }

          var modalDetails = { title: 'Quote Vendor Users (' + quote.quote_no + ')', component: 'modal-vendor-users', mstate: true, params: { vendorUsers: vendorUsers } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });

      },
      fncOpenCalc( quote ) {

        this.$store.dispatch('fncGetCalculators', quote);

        //window.open('https://builders.ndtecappsstaging.co.za/base/www/index.html?rangeredirect=true&id=2600468779&quoteId=' + quote.id, '_blank').focus();
      },
      fncCanClear() {
        if( this.$refs.searchField && this.$refs.searchField.lazyValue != '' ) {
          return true;
        }
        return false;
      },
      fncShowReps(repList, roleObj) {

        if( roleObj.label && roleObj.label != null ) {

          var roleLabel = roleObj.label;
          var subRoles = []

          var repSplit = repList.split( ',');

          for( var r in repSplit ) {
            if( repSplit[r].includes(roleLabel) == true ) {
              subRoles.push( repSplit[r] );
            }
          }

          if( subRoles.length == 0 ) {
            subRoles = ['N/A'];
          }

          subRoles = subRoles.join(',');

          return subRoles.replace(/,/g, "<br />");

        } else {

          //subRoles = subRoles.join(', ');

          if( repList.length > 70 ) {
            return repList.substr(0,70) + '...';
          } else {
            return repList;
          }

          //return repList.replace(/,/g, "<br />");
        }

      },
      fncShowRepsSub(repList, roleObj) {

        if( roleObj.label && roleObj.label != null ) {

          var roleLabel = roleObj.label;
          var subRoles = []

          var repSplit = repList.split( ',');

          for( var r in repSplit ) {

            var subSplit = repSplit[r].split('( ');

            if( subSplit.length > 1 ) {
              var subsubSplit = subSplit[1].split(' )');

              if( subsubSplit[0] == roleLabel ) {
                // if( repSplit[r].includes(roleLabel) == true ) {
                var subRep = repSplit[r].split('(');
                subRoles.push( subRep[0] );
                // subRoles.push( repSplit[r] );
              }
            }
          }

          if( subRoles.length == 0 ) {
            subRoles = ['N/A'];
          }

          subRoles = subRoles.join(', ');

          if( subRoles.length > 70 ) {
            return subRoles.substr(0,70) + '...';
          } else {
            return subRoles;
          }
          //return subRoles.replace(/,/g, "<br />");

        } else {
          if( repList.replace.length > 25 ) {
            return repList.replace.substr(0,25) + '...';
          } else {
            return repList.replace;
          }
          // return repList.replace(/,/g, "<br />");
        }

      },
      fncCheckProcessButton( payload ) {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_checked == 'Yes' && this.statusList[s].description == payload.status ) {
            return true;
          }
        }
        return false;
      },
      fncCheckProcessButtonText( payload ) {
        var hasText = false;
        for( var s in this.statusList ) {
          if( this.statusList[s].is_process_order == 'Yes' && this.statusList[s].description == payload.status ) {
            hasText = true;
            return '&nbsp;Order Processed';
          }
        }
        if( hasText == false ) {
          return '&nbsp;'+payload.status;
        }
      },
      fncSetResponsibleReps( setReps, roleId ) {
        var modalDetails = { title: 'Quote Responsible Reps (' + setReps.quote_no + ')', component: 'modal-set-reps', mstate: true, params: { object: setReps, roleId: roleId } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSetResponsibleKams( setReps ) {
        var modalDetails = { title: 'Quote Commercial KAM (' + setReps.quote_no + ')', component: 'modal-set-kams', mstate: true, params: { quote: setReps, kams: this.commercialKams } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSetResponsibleOriginator( setReps ) {
        var modalDetails = { title: 'Quote Commercial Co-Ordinator (' + setReps.quote_no + ')', component: 'modal-set-originators', mstate: true, params: { quote: setReps, originators: this.commercialOriginators } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCanDisplay( item ) {
        if( this.surveyListQuotes[item.id] == 3 && this.objAuthorize.type == 6 ) {
          return false;
        }
        return true;
      },
      fncNotificationHistory( quoteId ) {

        this.$store.commit('setNotificationHistoryLoaded', false);

        var modalDetails = { title: 'Notification History', component: 'modal-notification-history', mstate: true, params: { quote: quoteId } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

        /*this.$store.dispatch({
          type: 'fncNotificationHistory',
          quoteId: quoteId
        });*/
      },
      fncCheckSalesOrder( quote ) {
        if( this.objAuthorize.manufacturer == '385889803' ) {
          return false
        }
        else if( quote.sales_order_number && quote.sales_order_number != '' && quote.sales_order_number != '0' && quote.sales_order_number != 'N/A' ) {
          return true;
        }
        return false;
      },
      fncDownloadPdf(data) {
        for( var v in this.vendorList ) {
          if( this.vendorList[v].id == data.vendorId ) {
            data.vendorDetails = this.vendorList[v]
          }
        }
        this.$store.dispatch('fncDownloadReportSoPdfNew', data);
      },
      fncEditOriginator( quote ) {
        this.$store.dispatch({
          type: 'fncUpdateQuoteOriginator',
          quoteId: quote.id,
          originator: quote.originator
        });
      },
      fncReloadRepUsers( repUsers, selected, index ) {
        /*var repReturn = [];
        for( var r in repUsers ) {
          if( selected.indexOf( repUsers[r].id ) != -1 ) {
            repReturn.push( repUsers[r] );
          }
        }
        this.$refs['respReps'+index][0].items = repReturn;*/
      },
      fncGenerateRef( index ) {
        return 'respReps' + index;
      },
      fncGetRepUsers( quote, repUsers, selected ){

        /*console.log('Quote');
        console.log(quote.responsible_user_list);
        console.log(repUsers);*/

        var repReturn = [];
        // if( selected != undefined && selected != null ) {
          for( var r in quote.responsible_user_list ) {
            // if( selected.indexOf( repUsers[r].id ) != -1 ) {
            repReturn.push( { id: r, fullname: quote.responsible_user_list[r] } );
            // }
          }
        // }
        return repReturn;
      },
      fncGetSearchedQuoteReps( index, repUsers ) {
        this.$refs['respReps'+index][0].items = repUsers;
      },
      fncArchiveQuote( quote ) {
        this.$store.dispatch('fncArchiveQuote', quote.id)
      },
      fncEditSurveyDoc( quoteId ) {
        this.$store.dispatch('fncGetSurveyDocEdits', quoteId)
      },
      fncCloneQuote( quoteId, departmentId ) {
        // this.$store.dispatch('fncGeQuoteDetails', quoteId)
        this.$store.dispatch({
          type: 'fncGeQuoteDetails',
          quoteId: quoteId,
          departmentId: departmentId
        });
      },
      fncDownloadSurveyDoc( quoteId, quoteNo, formType ) {
        // this.$store.dispatch('fncGetSurveyDocDownload', quoteId)
        this.$store.dispatch({
          type: 'fncGetSurveyDocDownload',
          quoteId: quoteId,
          quoteNo: quoteNo,
          users: this.repUsers,
          branches: this.branchList,
          formType: formType
        })
      },
      fncCanEdit( quote ) {
        var canEdit = false;
        for( var s in this.statusList  ) {
          if( this.statusList[s].description == quote.status ) {
            if( s == 0 ) {
              canEdit = true;
            }
          }
        }
        return canEdit;
      },
      fncCheckSurveyDocument( quote ) {
        /*if( this.surveyList[quote.id] != undefined ) {
          return true;
        }
        return false;*/
        return true;
      },
      fncSetRepLabel( objReps ) {
        if( objReps == undefined ) {
          return 'Select Reps';
        }
      },
      fncEditQuoteReps( item ) {
        this.$store.dispatch('fncUpdateQuoteReps', item)
      },
      fncCheckDone( type ) {
        if( type == 'vendor' ) {
          if( this.$refs.vendorSelect !=  undefined && this.$refs.vendorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'status' ) {
          if( this.$refs.statusSelect !=  undefined && this.$refs.statusSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'customer' ) {
          if( this.$refs.customerSelect !=  undefined && this.$refs.customerSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'originator' ) {
          if( this.$refs.originatorSelect !=  undefined && this.$refs.originatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'store' ) {
          if( this.$refs.storeSelect !=  undefined && this.$refs.storeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'department' ) {
          if( this.$refs.departmentSelect !=  undefined && this.$refs.departmentSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'region' ) {
          if( this.$refs.regionSelect !=  undefined && this.$refs.regionSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'rep' ) {
          if( this.$refs.repSelect !=  undefined && this.$refs.repSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'kam' ) {
          if( this.$refs.kamSelect !=  undefined && this.$refs.kamSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'cOriginator' ) {
          if( this.$refs.cOriginatorSelect !=  undefined && this.$refs.cOriginatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'quote_type' ) {
          if( this.$refs.quoteTypeSelect !=  undefined && this.$refs.quoteTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'service_type' ) {
          if( this.$refs.serviceTypeSelect !=  undefined && this.$refs.serviceTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'projects' ) {
          if( this.$refs.projectsSelect !=  undefined && this.$refs.projectsSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'company' ) {
          if( this.$refs.companySelect !=  undefined && this.$refs.companySelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'linked_user' ) {
          if( this.$refs.linkedSelect !=  undefined && this.$refs.linkedSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'location' ) {
          if( this.$refs.locationSelect !=  undefined && this.$refs.locationSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncCheckChange( checkType ) {
        if( checkType == 'status' ) {
          if( this.$refs.statusSelect.isActive == false ) {
            if( JSON.stringify( this.objStatus ) != localStorage.getItem('cancelStatus') ) {
              if( this.objStatus[0] == 'all' ) {
                if( localStorage.getItem('cancelStatus') == null != undefined && localStorage.getItem('cancelStatus') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'customer' ) {
          if( this.$refs.customerSelect.isActive == false ) {
            if( JSON.stringify( this.objCustomerUser ) != localStorage.getItem('cancelCustomer') ) {
              if( this.objCustomerUser[0] == 'all' ) {
                if( localStorage.getItem('cancelCustomer') == null != undefined && localStorage.getItem('cancelCustomer') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'originator' ) {
          if( this.$refs.originatorSelect.isActive == false ) {
            if( JSON.stringify( this.objOriginator ) != localStorage.getItem('cancelOriginator') ) {
              if( this.objOriginator[0] == 'all' ) {
                if( localStorage.getItem('cancelOriginator') == null != undefined && localStorage.getItem('cancelOriginator') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'store' ) {
          if( this.$refs.storeSelect.isActive == false ) {
            if( JSON.stringify( this.objStore ) != localStorage.getItem('cancelStore') ) {
              if( this.objStore[0] == 'all' ) {
                if( localStorage.getItem('cancelStore') == null != undefined && localStorage.getItem('cancelStore') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'vendor' ) {
          if( this.$refs.vendorSelect.isActive == false ) {
            if( JSON.stringify( this.objVendor ) != localStorage.getItem('cancelVendor') ) {
              if( this.objVendor[0] == 'all' ) {
                if( localStorage.getItem('cancelVendor') == null != undefined && localStorage.getItem('cancelVendor') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'department' ) {
          if( this.$refs.departmentSelect.isActive == false ) {
            if( JSON.stringify( this.objDepartment ) != localStorage.getItem('cancelDepartment') ) {
              if( this.objDepartment[0] == 'all' ) {
                /*if( localStorage.getItem('cancelDepartment') == null != undefined && localStorage.getItem('cancelDepartment') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }*/
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'region' ) {
          if( this.$refs.regionSelect.isActive == false ) {
            if( JSON.stringify( this.objRegion ) != localStorage.getItem('cancelRegion') ) {
              if( this.objRegion[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'rep' ) {
          if( this.$refs.repSelect.isActive == false ) {
            if( JSON.stringify( this.objRep ) != localStorage.getItem('cancelRep') ) {
              if( this.objRep[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'kam' ) {
          if( this.$refs.kamSelect.isActive == false ) {
            if( JSON.stringify( this.objKam ) != localStorage.getItem('cancelKam') ) {
              if( this.objKam[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'cOriginator' ) {
          if( this.$refs.cOriginatorSelect.isActive == false ) {
            if( JSON.stringify( this.objcOriginator ) != localStorage.getItem('cancelcOriginator') ) {
              if( this.objcOriginator[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'quote_type' ) {
          if( this.$refs.quoteTypeSelect.isActive == false ) {
            if( JSON.stringify( this.objQuoteType ) != localStorage.getItem('cancelQuoteType') ) {
              if( this.objQuoteType[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'service_type' ) {
          if( this.$refs.serviceTypeSelect.isActive == false ) {
            if( JSON.stringify( this.objServiceType ) != localStorage.getItem('cancelServiceType') ) {
              if( this.objServiceType[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'projects' ) {
          if( this.$refs.projectsSelect.isActive == false ) {
            if( JSON.stringify( this.objProjects ) != localStorage.getItem('cancelProjects') ) {
              if( this.objProjects[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'company' ) {
          if( this.$refs.companySelect.isActive == false ) {
            if( JSON.stringify( this.objCompany ) != localStorage.getItem('cancelCompany') ) {
              if( this.objCompanies[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'linked_user' ) {
          if( this.$refs.linkedSelect.isActive == false ) {
            if( JSON.stringify( this.objLinkedUser ) != localStorage.getItem('cancelLinked') ) {
              if( this.objLinkedUser[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'location' ) {
          if( this.$refs.locationSelect.isActive == false ) {
            if( JSON.stringify( this.objLocation ) != localStorage.getItem('cancelLocation') ) {
              if( this.objLocation[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        }
      },
      fncClearLabels( type ) {
        if( type == 'originator' ) {
          this.hideOriginatorLabels = true;
        }
      },
      fncShowLabels( type ) {
        if( type == 'originator' ) {
          this.hideOriginatorLabels = false;
        }
      },
      fncShowPaginationRecords() {

        var startPage = ( this.page * 10 ) - 9;
        var endPage = ( this.page * 10 );

        if( endPage > this.totalQuoteRecords ) {
          endPage = this.totalQuoteRecords;
        }

        return '<p>Viewing '+startPage+' - '+endPage+' of ' + this.totalQuoteRecords + ' records</p>';
      },
      fncClearFilterShadows() {
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;
      },
		fncCloseDrawer() {
			// this.filterDrawer = false;

      if( window.localStorage.cancelCompany != undefined && window.localStorage.cancelCompany != null ) {
        localStorage.setItem('reportCompany', localStorage.getItem('cancelCompany'));
      }

      if( window.localStorage.cancelVendor != undefined && window.localStorage.cancelVendor != null ) {
        localStorage.setItem('reportVendors', localStorage.getItem('cancelVendor'));
      }

      if( window.localStorage.cancelStore != undefined && window.localStorage.cancelStore != null ) {
        localStorage.setItem('reportStores', localStorage.getItem('cancelStore'));
      }

      if( window.localStorage.cancelDepartment != undefined && window.localStorage.cancelDepartment != null ) {
        localStorage.setItem('reportDepartments', localStorage.getItem('cancelDepartment'));
      }

      if( window.localStorage.cancelOriginator != undefined && window.localStorage.cancelOriginator != null ) {
        localStorage.setItem('reportOriginators', localStorage.getItem('cancelOriginator'));
      }

      if( window.localStorage.cancelCustomer != undefined && window.localStorage.cancelCustomer != null ) {
        localStorage.setItem('cancelCustomer', localStorage.getItem('cancelCustomer'));
      }

      if( window.localStorage.cancelStatus != undefined && window.localStorage.cancelStatus != null ) {
        localStorage.setItem('reportStatus', localStorage.getItem('cancelStatus'));
      }

      if( window.localStorage.cancelKam != undefined && window.localStorage.cancelKam != null ) {
        localStorage.setItem('reportKams', localStorage.getItem('cancelKam'));
      }

      if( window.localStorage.cancelcOriginator != undefined && window.localStorage.cancelcOriginator != null ) {
        localStorage.setItem('reportcOriginator', localStorage.getItem('cancelcOriginator'));
      }

      if( window.localStorage.cancelQuoteType != undefined && window.localStorage.cancelQuoteType != null ) {
        localStorage.setItem('reportQuoteType', localStorage.getItem('cancelQuoteType'));
      }

      if( window.localStorage.cancelServiceType != undefined && window.localStorage.cancelServiceType != null ) {
        localStorage.setItem('reportServiceType', localStorage.getItem('cancelServiceType'));
      }

      if( window.localStorage.cancelReportDate != undefined && window.localStorage.cancelReportDate != null ) {
        var newReportDate = localStorage.getItem('cancelReportDate').split(',');
        if( newReportDate[0] == '1900-01-01' ) {
          newReportDate[0] = '';
        }
        localStorage.setItem('reportDates', newReportDate.toString());
        //localStorage.setItem('reportDates', localStorage.getItem('cancelReportDate'));
        this.reportDate = newReportDate;
        localStorage.setItem('quote_start_date', newReportDate[0].toString());
        localStorage.setItem('quote_end_date', newReportDate[1].toString());

        //this.reportDate = localStorage.getItem('cancelReportDate');
      }

      if( window.localStorage.cancelQuoteSetDays != undefined && window.localStorage.cancelQuoteSetDays != null ) {
        localStorage.setItem('quoteSetDays', localStorage.getItem('cancelQuoteSetDays'));
      }

      this.filterDrawer = false;
      localStorage.removeItem('secondTab')
      console.log('filterDrawer')
      this.secondTab = null
      // do a reload
      /*setTimeout(function() {
        // location.reload();
        this.filterDrawer = false;
      }, 500)*/


		},
      fncHideAllPops() {
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;
      },
      fncDisplayBottomTabValue(topKey,bottomKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (data.hasOwnProperty(0)) {
                for (const [thirdKey, tab] of Object.entries(data[0])) {
                  if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                    return 'R'+ data[0][thirdKey][bottomKey].total
                  }
                }
            }

          }
        }
      },
      fncDisplayBottomTabCount(topKey,bottomKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (data.hasOwnProperty(0)) {
              for (const [thirdKey, tab] of Object.entries(data[0])) {
                if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                  return data[0][thirdKey][bottomKey].total_count
                }
              }
            }

          }
        }
      },
      fncDisplayTopTabValue(topKey)
      {
        if (this.topTabsCount !== undefined && Object.keys(this.topTabsCount).length !== 0){
          for (const [key, value] of Object.entries(this.topTabsCount)) {
            for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
              if (secondKey === topKey){
                if (this.topTabsCount[key][secondKey].total === 0)
                  return  'R0.0'
                else{

                  return 'R'+ this.topTabsCount[key][secondKey].total
                }
              }
            }
          }
      }
        return  'R0.0'
      },
      fncDisplayTopTabCount(topKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (secondKey === topKey){
              return this.topTabsCount[key][secondKey].total_count
            }
          }
        }
        return 0
      },
      fncShowFilterPop(headerText) {
        if( headerText == 'Quote Date' ) {
          this.dateFilterShow = false;
        }
        if( headerText == 'Vendor' ) {
          if( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) {
            this.vendorFilterShow = this.vendorFilterShow == false ? true : false;
          } else {
            this.vendorFilterShow = false;
          }
        }
        if( headerText == 'Department' ) {
          if( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) {
            this.departmentFilterShow = this.departmentFilterShow == false ? true : false;
          } else {
            this.departmentFilterShow = false;
          }
        }
        if( headerText == 'Store' ) {
          if( this.objStore.length > 0 && this.objStore[0] != 'all' ) {
            this.storeFilterShow = this.storeFilterShow == false ? true : false;
          } else {
            this.storeFilterShow = false;
          }
        }
        if( headerText == 'Originator Name' ) {
          if( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) {
            this.originatorFilterShow = this.originatorFilterShow == false ? true : false;
          } else {
            this.originatorFilterShow = false;
          }
        }
        if( headerText == 'Customer Name' ) {
          if( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) {
            this.customerFilterShow = this.customerFilterShow == false ? true : false;
          } else {
            this.customerFilterShow = false;
          }
        }
        if( headerText == 'Status' ) {
          this.statusFilterShow = false;
          // if( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) {
          //   this.statusFilterShow = this.statusFilterShow == false ? true : false;
          // } else {
          //   this.statusFilterShow = false;
          // }
        }
        if( headerText == 'Region' ) {
          if( this.objRegion.length > 0 && this.objRegion[0] != 'all' ) {
            this.regionFilterShow = this.regionFilterShow == false ? true : false;
          } else {
            this.regionFilterShow = false;
          }
        }
        if( headerText == 'Responsible Rep' ) {
          if( this.objRep.length > 0 && this.objRep[0] != 'all' ) {
            this.repFilterShow = this.repFilterShow == false ? true : false;
          } else {
            this.repFilterShow = false;
          }
        }

      },
      fncSetDateEmpty() {
        localStorage.setItem('quoteSetDays', '');
        this.fncReloadFilters();
        /*this.regenFalse = false;
        this.$store.commit('fncFilterNeedsReload', true);
        this.$store.dispatch({
          type: 'fncPopulateDashboard',
          date_from: 'null',
          date_to: 'null',
          region: 'null',
          status: this.objStatus,
          originator: this.objOriginator,
          customer: this.objCustomerUser,
          store: this.objStore,
          vendor: this.objVendor,
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: this.reportDate[0],
          end_date: this.reportDate[1],
          ignoreFilters: true,
          filter_only: true,
          search: this.search
        })*/
      },
      fncSearchLabel() {
        if(
          ( ( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) ||
            ( this.objStore.length > 0 && this.objStore[0] != 'all' ) ||
            ( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) ||
            ( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) ||
            ( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) ||
            ( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) ) ||
            ( this.reportDate[0] != '' ) ||
            ( this.reportDate[1] != '' )
        ) {
          return 'Search Current Filtered Quotes';
        } else {
          return 'Search All Quotes';
        }

      },
      fncQuoteSearchLabel() {
        return 'Quote Number';
      },
      fncCheckHeaderFilter( headerText ) {
        if( headerText == 'Quote Date' ) {
          if( this.reportDate != '' && ( this.reportDate[0] != '' || this.reportDate[1] != '' ) ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Vendor' ) {
          if( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Store' ) {
          if( this.objStore.length > 0 && this.objStore[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Originator Name' ) {
          if( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Customer Name' ) {
          if( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Status' ) {
          if( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Responsible Rep' ) {
          if( this.objRep.length > 0 && this.objRep[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Kam Region' ) {
          if (this.objRegion.length > 0 && this.objRegion[0] != 'all') {
            return '<span class="rowHasFilter">' + headerText.toUpperCase() + '<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>' + headerText + '</span>';
          }
        } else if( headerText == 'Department' ) {
            if( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) {
              return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
            } else {
              return '<span>'+headerText+'</span>';
            }
          } else {
          return headerText;
        }
      },
      fncShowColumns() {
        var modalDetails = { title: 'Filter Columns', component: 'modal-filter-columns', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCreateLead(){
        this.$store.commit('fncSetUserLoading', true);
        this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncPopulateUserVendors');
        this.$store.dispatch('fncSetupUserCreate', 'user');
        this.$store.dispatch({
          type: 'fncGeLeadDetails'
        });
      },
      getTab(key, description) {
        if( description == 'main' ) {

          localStorage.setItem('liteMainTab', key);
          this.liteMainTab = key;

          // also need to automate the first tab of the sub set
          localStorage.setItem('liteSubTab', Object.keys(this.quotesLite[key])[0]);

          this.liteSubTab = Object.keys(this.quotesLite[key])[0];

          if( this.liteSubTab == 'all' ) {
            this.activeTabSub = '0';
          }

        } else if( description == 'sub' ) {
          localStorage.setItem('liteSubTab', key);
          this.liteSubTab = key;
        }

        /*var subTab = localStorage.getItem('liteSubTab');

        // now we need to run the data as well
        var dToday = new Date();
        var startDate = this.reportStartDate;

        if( startDate == '' ) {

          var newStartDate = new Date(new Date().setDate(dToday.getDate() - 30));
          startDate = newStartDate.toISOString().split('T')[0];

          this.reportStartDate = startDate;
          localStorage.setItem('reportStartDate', this.reportStartDate);

        }

        var endDate = this.reportEndDate;

        if( endDate == '' ) {
          endDate = dToday.toISOString().split('T')[0];

          this.reportEndDate = endDate;
          localStorage.setItem('reportEndDate', this.reportEndDate);
        }

        if( this.reportStartDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( this.reportEndDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        if( subTab == 'all' ) {
          this.$store.dispatch({
            'type': 'fncQuoteReportLite',
            'status': this.filterStatus,
            'department': this.filterDepartment,
            'store': this.filterStore,
            'customer': this.filterCustomer,
            'startDate': startDate,
            'endDate': endDate,
            'vendor': this.filterVendor,
            'company': this.filterCompany,
            'originator': this.filterOriginator,
            'project': this.filterProject,
            'service_type': this.filterServiceType
          });
        } else {
          this.$store.dispatch({
            'type': 'fncQuoteReportLite',
            'status': this.filterStatus,
            'department': this.filterDepartment,
            'store': this.filterStore,
            'customer': this.filterCustomer,
            'startDate': startDate,
            'endDate': endDate,
            'vendor': this.filterVendor,
            'company': this.filterCompany,
            'originator': this.filterOriginator,
            'project': this.filterProject,
            'service_type': this.filterServiceType,
            'tab': subTab
          });
        }*/

        // window.location.reload();

      },
      getTabs(key){


        this.secondTab = null
        localStorage.removeItem("secondTab")
        this.selectedStatus = null
       // //
        if ( localStorage.getItem('reportStatus') !== null){
       //    this.objStatus = []
       //    let arr = []
       //    this.chageTopreviousTab = false
       //
       //    for (let i = 0; i < this.tabs[key].length; i++) {
       //      arr.push(this.tabs[key][i]['description'])
       //    }
          this.objStatus = JSON.parse(localStorage.getItem('reportStatus'));

          this.fncCheckDropdowns('status');
          this.fncSearchNewQuotes(false,true);
       }
        else {
          this.objStatus =['all']
          this.fncCheckDropdowns('status');
          this.fncSearchNewQuotes(false,true);
          //this.fncReloadQuotes()
        }


      },
      fncReloadQuotes() {
        this.$store.commit('fncEmptyQuoteList');
        this.$store.commit('fncSetQuoteReportLoaded', false);
        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          //company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          reload: true,
          start_date: localStorage.getItem("quote_start_date"),
          end_date: localStorage.getItem("quote_end_date")
        })
      },
      fncCheckDropdowns(type) {
        this.regenFalse = false;
        var newFilter = [];
        var isAll = false;
        var addedObj = false;
        if( type == 'department' ) {
          for( var v in this.filterDepartment ) {
            if( this.filterDepartment[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterDepartment[this.filterDepartment.length -1];
          if( isAll == true && this.filterDepartment.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.filterDepartment ) {
              if (this.filterDepartment[v] != 'all') {
                newFilter.push(this.filterDepartment[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterDepartment = newFilter;
        } else if( type == 'vendor' ) {
          for( var v in this.filterVendor ) {
            if( this.filterVendor[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterVendor[this.filterVendor.length -1];
          if( isAll == true && this.filterVendor.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.filterVendor ) {
              if (this.filterVendor[v] != 'all') {
                newFilter.push(this.filterVendor[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterVendor = newFilter;
        } else if( type == 'store' ) {
          for( var s in this.filterStore ) {
            if( this.filterStore[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterStore[this.filterStore.length -1];
          if( isAll == true && this.filterStore.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.filterStore ) {
              if (this.filterStore[s] != 'all') {
                newFilter.push(this.filterStore[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterStore = newFilter;
        } else if( type == 'originator' ) {

          this.hideOriginatorLabels = true;

          for( var o in this.filterOriginator ) {
            if( this.filterOriginator[o] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterOriginator[this.filterOriginator.length -1];
          if( isAll == true && this.filterOriginator.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var o in this.filterOriginator ) {
              if (this.filterOriginator[o] != 'all') {
                newFilter.push(this.filterOriginator[o]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterOriginator = newFilter;
        } else if( type == 'customer' ) {
          for( var c in this.filterCustomer ) {
            if( this.filterCustomer[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterCustomer[this.filterCustomer.length -1];
          if( isAll == true && this.filterCustomer.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterCustomer ) {
              if (this.filterCustomer[c] != 'all') {
                newFilter.push(this.filterCustomer[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterCustomer = newFilter;
        } else if( type == 'status' ) {
          for( var s in this.filterStatus ) {
            if( this.filterStatus[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterStatus[this.filterStatus.length -1];
          if( isAll == true && this.filterStatus.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.filterStatus ) {
              if (this.filterStatus[s] != 'all') {
                newFilter.push(this.filterStatus[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterStatus = newFilter;
        } else if( type == 'rep' ) {
          for( var s in this.filterRep ) {
            if( this.filterRep[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterRep[this.filterRep.length -1];
          if( isAll == true && this.filterRep.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.filterRep ) {
              if (this.filterRep[s] != 'all') {
                newFilter.push(this.filterRep[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterRep = newFilter;
        } else if( type == 'quote_type' ) {
          for( var c in this.filterQuoteType ) {
            if( this.filterQuoteType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterQuoteType[this.filterQuoteType.length -1];
          if( isAll == true && this.filterQuoteType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterQuoteType ) {
              if (this.filterQuoteType[c] != 'all') {
                newFilter.push(this.filterQuoteType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterQuoteType = newFilter;
        } else if( type == 'service_type' ) {
          for( var c in this.filterServiceType ) {
            if( this.filterServiceType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterServiceType[this.filterServiceType.length -1];
          if( isAll == true && this.filterServiceType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterServiceType ) {
              if (this.filterServiceType[c] != 'all') {
                newFilter.push(this.filterServiceType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterServiceType = newFilter;
        } else if( type == 'projects' ) {
          for( var c in this.filterProjects ) {
            if( this.filterProjects[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterProjects[this.filterProjects.length -1];
          if( isAll == true && this.filterProjects.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterProjects ) {
              if (this.filterProjects[c] != 'all') {
                newFilter.push(this.filterProjects[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterProjects = newFilter;
        } else if( type == 'company' ) {
          for( var c in this.filterCompany ) {
            if( this.filterCompany[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterCompany[this.filterCompany.length -1];
          if( isAll == true && this.filterCompany.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterCompany ) {
              if (this.filterCompany[c] != 'all') {
                newFilter.push(this.filterCompany[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterCompany = newFilter;
        } else if( type == 'linked_user' ) {
          for( var c in this.filterLinkedUser ) {
            if( this.filterLinkedUser[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterLinkedUser[this.filterLinkedUser.length -1];
          if( isAll == true && this.filterLinkedUser.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterLinkedUser ) {
              if (this.filterLinkedUser[c] != 'all') {
                newFilter.push(this.filterLinkedUser[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterLinkedUser = newFilter;
        }  else if( type == 'location' ) {
          for( var c in this.filterLocation ) {
            if( this.filterLocation[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.filterLocation[this.filterLocation.length -1];
          if( isAll == true && this.filterLocation.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.filterLocation ) {
              if (this.filterLocation[c] != 'all') {
                newFilter.push(this.filterLocation[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.filterLocation = newFilter;
        }
        // this.fncReloadFilters();
      },
      fncReloadFilters() {
        this.$store.commit('fncFilterNeedsReload', true);
        this.fncShowFilterSlideSub();
      },
      fncShowFilterSlide( slideOut = true ) {

        if( this.filterNeedsReload == true ) {

        // what we need to do here is to duplicate the current local storages and make sure that we can revert when cancelled
        var cancelVendor = ['all'];
        if (window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null) {
          cancelVendor = window.localStorage.reportVendors;
          localStorage.setItem('cancelVendor', cancelVendor);
        } else {
          localStorage.removeItem('cancelVendor');
        }

        var cancelStore = ['all'];
        if (window.localStorage.reportStores != undefined && window.localStorage.reportStores != null) {
          cancelStore = window.localStorage.reportStores;
          localStorage.setItem('cancelStore', cancelStore);
        } else {
          localStorage.removeItem('cancelStore');
        }

        var cancelDepartment = ['all'];
        if (window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null) {
          cancelDepartment = window.localStorage.reportDepartments;
          localStorage.setItem('cancelDepartment', cancelDepartment);
        } else {
          localStorage.removeItem('cancelDepartment');
        }

        var cancelOriginator = ['all'];
        if (window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null) {
          cancelOriginator = window.localStorage.reportOriginators;
          localStorage.setItem('cancelOriginator', cancelOriginator);
        } else {
          localStorage.removeItem('cancelOriginator');
        }

        var cancelCustomer = ['all'];
        if (window.localStorage.reportUsers != undefined && window.localStorage.reportUsers != null) {
          cancelCustomer = window.localStorage.reportUsers;
          localStorage.setItem('cancelCustomer', cancelCustomer);
        } else {
          localStorage.removeItem('cancelCustomer');
        }

        var cancelStatus = ['all'];
        if (window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null) {
          cancelStatus = window.localStorage.reportStatus;
          localStorage.setItem('cancelStatus', cancelStatus);
        } else {
          localStorage.removeItem('cancelStatus');
        }

        var cancelKam = ['all'];
        if (window.localStorage.reportKams != undefined && window.localStorage.reportKams != null) {
          cancelKam = window.localStorage.cancelKam;
          localStorage.setItem('cancelKam', cancelKam);
        } else {
          localStorage.removeItem('cancelKam');
        }

        var cancelQuoteType = ['all'];
        if (window.localStorage.reportQuoteType != undefined && window.localStorage.reportQuoteType != null) {
          cancelQuoteType = window.localStorage.cancelQuoteType;
          localStorage.setItem('cancelQuoteType', cancelQuoteType);
        } else {
          localStorage.removeItem('cancelQuoteType');
        }

        var cancelServiceType = ['all'];
        if (window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null) {
          cancelServiceType = window.localStorage.cancelServiceType;
          localStorage.setItem('cancelServiceType', cancelServiceType);
        } else {
          localStorage.removeItem('cancelServiceType');
        }

        var cancelProjects = ['all'];
        if (window.localStorage.reportProjects != undefined && window.localStorage.reportProjects != null) {
          cancelProjects = window.localStorage.cancelProjects;
          localStorage.setItem('cancelProjects', cancelProjects);
        } else {
          localStorage.removeItem('cancelProjects');
        }

        var cancelCompany = ['all'];
        if (window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null) {
          cancelCompany = window.localStorage.cancelCompany;
          localStorage.setItem('cancelCompany', cancelCompany);
        } else {
          localStorage.removeItem('cancelCompany');
        }

        var cancelcOriginator = ['all'];
        if (window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null) {
          cancelcOriginator = window.localStorage.cancelKam;
          localStorage.setItem('cancelcOriginator', cancelcOriginator);
        } else {
          localStorage.removeItem('cancelcOriginator');
        }

        var cancelReportDate = [];
        if (window.localStorage.reportDates != undefined && window.localStorage.reportDates != null) {
          cancelReportDate = window.localStorage.reportDates;
          localStorage.setItem('cancelReportDate', cancelReportDate);
        } else {
          localStorage.removeItem('cancelReportDate');
        }

        var cancelQuoteSetDays = 0;
        if (window.localStorage.quoteSetDays != undefined && window.localStorage.quoteSetDays != null) {
          cancelQuoteSetDays = window.localStorage.quoteSetDays;
          localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
        } else {
          // localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
          localStorage.removeItem('cancelQuoteSetDays');
        }

        var cancelRegions = ['all'];
        if (window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null) {
          cancelRegions = window.localStorage.reportRegions;
          localStorage.setItem('cancelRegions', cancelRegions);
        } else {
          localStorage.removeItem('cancelRegions');
        }

        var cancelReps = ['all'];
        if (window.localStorage.reportReps != undefined && window.localStorage.reportReps != null) {
          cancelReps = window.localStorage.reportReps;
          localStorage.setItem('cancelReps', cancelReps);
        } else {
          localStorage.removeItem('cancelReps');
        }

        this.regenFalse = true;

        localStorage.removeItem('reportSearch');
        this.search = ''
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        if (slideOut == true) {
          this.filterDrawer = true;
        }

        // this.$store.commit('fncFilterNeedsReload', true);

        // if (this.filterNeedsReload == true) {

          this.$store.dispatch({
            type: 'fncRetrieveFilters',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            department: this.objDepartment,
            customer: this.objCustomerUser,
            store: this.objStore,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            ignoreFilters: true,
            filter_only: true,
            //search: this.search,
            search: '',
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            pricelist: false,
            slideout: this.slideOut
          })
        // }
      } else {
          this.filterDrawer = true;
        }

      },
      fncGetStatusCount(){
        var modalDetails = { title: 'SUMMARY BY STATUS', component: 'modal-quote-totals', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

        this.regenFalse = true;

        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        //this.filterDrawer = true;
        //this.$store.commit( 'fncFilterNeedsReload', true );

        if( this.filterNeedsReload == true ) {

          this.$store.dispatch({
            type: 'fncPopulateDashboard',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            customer: this.objCustomerUser,
            store: this.objStore,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: 'null',
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            ignoreFilters: true,
            filter_only: true,
            search: this.search,
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            tabs: this.tabs,
            department: this.objDepartment
          })
        }
      },
      fncShowFilterSlideSub() {

        this.regenFalse = true;

        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        this.filterDrawer = true;
        this.$store.commit( 'fncFilterNeedsReload', true );

        if( this.filterNeedsReload == true ) {

          this.$store.dispatch({
            type: 'fncRetrieveFilters',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            department: this.objDepartment,
            customer: this.objCustomerUser,
            store: this.objStore,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            /*start_date: '1900-01-01',
            end_date: '2020-06-06',*/
            ignoreFilters: true,
            filter_only: true,
            //search: this.search,
            search: '',
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
          })
        }
      },
      fncSearchClearNewQuotes() {

        /*localStorage.removeItem('quote_start_date');
        localStorage.removeItem('quote_end_date');
        localStorage.removeItem('reportDates');
        localStorage.removeItem('quoteSetDays');*/

        localStorage.removeItem('cancelVendor');
        localStorage.removeItem('cancelStore');
        localStorage.removeItem('cancelDepartment');
        localStorage.removeItem('cancelOriginator');
        localStorage.removeItem('cancelCustomer');
        localStorage.removeItem('cancelRegion');
        localStorage.removeItem('cancelRep');
        localStorage.removeItem('cancelKam');
        localStorage.removeItem('cancelcOriginator');
        localStorage.removeItem('cancelReportDate');
        localStorage.removeItem('cancelQuoteSetDays');
        localStorage.removeItem('cancelProjects');
        localStorage.removeItem('cancelStatus');

        this.regenFalse = false;
        /*this.reportDate[0] = '';
        var dToday = new Date();
        var quote_age_end = dToday.toISOString().split('T')[0];
        this.reportDate[1] = quote_age_end;*/
        this.quoteFilter = '';
        this.search = '';
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.objOriginator = ['all'];
        this.objCustomerUser = ['all'];
        this.objStatus = ['all'];

        localStorage.removeItem('secondTab')
        console.log('reportStatus')
        localStorage.removeItem('topTab')
        //localStorage.setItem('topTab', '0')
        localStorage.removeItem('reportStatus');
        this.objRegion = ['all'];
        this.objRep = ['all'];
        this.objKam = ['all'];
        this.objQuoteType = ['all'];
        this.objServiceType = ['all'];
        this.objcOriginator = ['all'];
        this.objProjects = ['all'];
        this.objCompany = ['all'];
        localStorage.removeItem('secondTab')

        this.secondTab = null
        this.selectedStatus = null

		    this.fncSearchNewQuotes(false,true);

      },
      fncClearFilter() {

        /*localStorage.removeItem('quote_start_date');
        localStorage.removeItem('quote_end_date');*/
        // localStorage.removeItem('reportDates');
        localStorage.removeItem('quoteSetDays');

        this.regenFalse = false;
        /*this.reportDate[0] = '';
        this.reportDate[1] = '';*/
        this.quoteFilter = '';
        this.search = '';
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.objOriginator = ['all'];
        this.objCustomerUser = ['all'];
        this.objStatus = ['all'];
        this.objRegion = ['all'];
        this.objRep = ['all'];
        this.objKam = ['all'];
        this.objQuoteType = ['all'];
        this.objServiceType = ['all'];
        this.objcOriginator = ['all'];
        this.objProjects = ['all'];
        this.objCompany = ['all'];

        this.fncReloadFilters();
      },
      fncHideFilter() {
        this.filterDrawer = false;
      },
      fncSetFilters( type ) {

        var toReturn = [{ id: 'all', name: 'All' }];
        var filters = this.newReportFilters;

        if( type == 'vendor' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) != -1 ) {
              isSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) == -1 ) {
              isNotSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'store' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: filters.store[s]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: filters.store[s]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'status' ) {

          /* if( this.departmentList.length > 0 ) {

            var simpleDepartmentList = [];
            for( var d in this.departmentList ) {
              simpleDepartmentList[this.departmentList[d].id] = this.departmentList[d].name;
            }

            var depStatuses = [];
            //depStatuses[0] = 'No Department Assigned';
            for( var s in this.statusList ) {
              for( var fs in filters.status ) {
                if( this.statusList[s].description == fs  ) {
                  if( depStatuses[this.statusList[s].department] == null ) {
                    depStatuses[this.statusList[s].department] = [];
                  }
                  depStatuses[this.statusList[s].department].push( this.statusList[s] );
                }
              }
            }

            var isSelected = [];

            for( var ds in depStatuses ) {
              if( ds == 0 ) {
                isSelected.push({header: 'No Department Assigned'});
              } else {
                isSelected.push({header: simpleDepartmentList[ds]});
              }
              for( var dss in depStatuses[ds] ) {
                isSelected.push({id: depStatuses[ds][dss].description, name: depStatuses[ds][dss].description});
              }
            }

            toReturn = toReturn.concat(isSelected);

          } else { */
            var isSelected = [];
            var isNotSelected = [];
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) != -1 ) {
                isSelected.push({id: s, name: s});
              }
            }
            isSelected.sort((a, b) => a.name.localeCompare(b.name));
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) == -1 ) {
                isNotSelected.push({id: s, name: s});
              }
            }
            isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
            toReturn = toReturn.concat(isSelected);
            toReturn = toReturn.concat(isNotSelected);
          // }
        } else if( type == 'originator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'customer' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) != -1 ) {
              isSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) == -1 ) {
              isNotSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'department' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: d, name: filters.department[d] });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: d, name: filters.department[d] });
            }
          }
          // isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          isNotSelected.sort((a, b) => {
            if (a.name && b.name) {
              return a.name.localeCompare(b.name);
            } else if (!a.name && b.name) {
              return -1; // Move null values to the end of the sorted array
            } else if (a.name && !b.name) {
              return 1; // Move null values to the end of the sorted array
            } else {
              return 0; // Both names are null, no need to sort
            }
          });
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'region' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var d in filters.regions ) {
            if( this.objRegion.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: filters.regions[d], name: filters.regions[d] });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.regions ) {
            if( this.objRegion.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: filters.regions[d], name: filters.regions[d] });
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'rep' ) {
          var isSelected = [];
          var isNotSelected = [];
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) != -1) {
              isSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) == -1) {
              isNotSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'kam' ) {
            var isSelected = [];
            var isNotSelected = [];
            for( var o in filters.commercial_kam ) {
              if( this.objKam.indexOf(String(o)) != -1 ) {
                isSelected.push({id: o, name: filters.commercial_kam[o]});
              }
            }
            isSelected.sort((a, b) => a.name.localeCompare(b.name));
            for( var o in filters.commercial_kam ) {
              if( this.objKam.indexOf(String(o)) == -1 ) {
                isNotSelected.push({id: o, name: filters.commercial_kam[o]});
              }
            }
            isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
            toReturn = toReturn.concat(isSelected);
            toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'cOriginator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'quote_type' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'service_type' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'projects' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'company' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }

        return toReturn;

      },
      fncGetRecordCount() {
        /*if( this.quoteSearchList == undefined || this.quoteSearchList == null ) {
          return 0;
        } else if( this.quoteSearchList.length > 0 ) {
          return this.quoteSearchList[0].total_records;
        } else {
          return 0;
        }*/

        return this.totalQuoteRecords;
      },
      fncHideLinkedQuotes() {

        this.$router.push({path: '/reports/quote-reports-lite', query: 1});
        this.$router.go();

        /*this.quotesLinked = false;
        this.$store.commit( 'fncSetQuoteListOutright', this.quoteSearchListSet );*/
      },
      fncGetStatusDropdown( objItem, quoteId) {

        var currentStatus = objItem.status;
        var currentStatusOrder = -1;

        if( this.objAuthorize.department_active == 0 || this.objAuthorize.department_status_share == 1 ) {
          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          var newFilterStatus = [];
          for( var f in this.filterStatusSet ) {
            this.filterStatusSet[f].disabled = false;
            newFilterStatus.push( this.filterStatusSet[f] );
          }

          for( var f in newFilterStatus ) {
            if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }
            if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = f;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = f;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = f;
            }
          }

          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
            for (var f in newFilterStatus) {
              if( parseInt(currentStatusOrder) < parseInt(isChecked) && parseInt(f) < parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(f) >= parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else if ( parseInt(f) < parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }

        } else {

          var returnDepartment = 0;
          var departmentName = [];

          var hasDepartment = false;
          var productCodes = objItem.pCodes.split(',');

          if( this.surveyList[objItem.id] != undefined && this.surveyList[objItem.id] != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == this.surveyList[objItem.id] ) {
                returnDepartment = this.departmentList[d].id;
                theDepartment = this.departmentList[d].id;
                hasDepartment = true;
              }
            }
          }

          if( hasDepartment == false ) {
            var theDepartment = this.fncGetDepartmentId( objItem );
          }

          if( productCodes.length > 0 && hasDepartment == false ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].id;
                      hasDepartment = true;
                    }
                  }
                }
              }
            }
          }

          if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == true && returnDepartment == 0 ) {
            var departmentRanges = this.departmentList;
            var filteredQuotes = [];
            var quoteRanges = objItem.range_id.split(',');
            for( var d in departmentRanges ) {
              for( var qr in quoteRanges ) {
                for( var dr in departmentRanges[d].ranges ) {
                  if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                    departmentName.push( departmentRanges[d].id );
                  }
                }
              }
            }
            var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
            if( uniqueDepartment.length == 0 ) {
              if( objItem.originator_department != '' && objItem.originator_department != null ) {
                for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.originator_department ) {
                    returnDepartment = this.departmentList[d].id;
                    hasDepartment = true;
                  }
                }
              } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                returnDepartment = objItem.departmentUser;
              } else {
                var productCodes = [];
                var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                if( line_item_data.length > 0 ) {
                  for( var l in line_item_data ) {
                    var lineObj = JSON.parse( line_item_data[l] );
                    if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                      productCodes.push(lineObj.product_code);
                    }
                  }
                }
                if( productCodes.length > 1 ) {
                  returnDepartment = 0;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].id;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            } else if( uniqueDepartment.length > 1 ) {
              if( objItem.originator_department != '' && objItem.originator_department != null ) {
                returnDepartment = objItem.originator_department;
              } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                returnDepartment = objItem.departmentUser;
                hasDepartment = true;
              } else {
                returnDepartment = 0;
                hasDepartment = true;
              }
            } else {
              returnDepartment = uniqueDepartment[0];
              hasDepartment = true;
            }
          }

          // now that we have the department id we can display the correct statuses
          var returnStatuses = [];
          var loggedRole =  this.objAuthorize.roles[0];

          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          for( var s in this.filterStatus ) {
            var statusRoles = this.filterStatus[s].roles != null ? this.filterStatus[s].roles.split(',') : [];
            if( this.filterStatus[s].department != null ) {
              var objDepartments = this.filterStatus[s].department.split(',');
            } else {
              var objDepartments = [];
            }

            if( theDepartment == 'N/A' ) {
              returnDepartment = 0;
            } else {
              returnDepartment = theDepartment;
            }

            returnDepartment = objItem.departmentId;

            // if( returnDepartment == this.filterStatus[s].department && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
            if( objDepartments.indexOf(String(returnDepartment)) != -1 && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( returnDepartment == 0 && objDepartments.length == 0) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( this.filterStatus[s].description == currentStatus ) {
              currentStatusOrder = this.filterStatus[s].order;
            }

            if( this.filterStatus[s].can_back_after_payment == 'Yes' ) {
              canBack = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].is_checked == 'Yes' ) {
              isChecked = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].can_forward_before_payment == 'Yes' ) {
              canForward = this.filterStatus[s].order;
            }

          }

          /* ------------------ */

          var newFilterStatus = [];
          for( var f in returnStatuses ) {
            returnStatuses[f].disabled = false;
            newFilterStatus.push(returnStatuses[f]);
          }

          for( var f in newFilterStatus ) {
            /*if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }*/
            /*if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = newFilterStatus[f].order;
            }*/
          }


          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

            for (var f in newFilterStatus) {

              var statusOrder = newFilterStatus[f].order;

              if( parseInt(currentStatusOrder) == parseInt(isChecked) ) {
                if( parseInt(statusOrder) > parseInt( isChecked ) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) <= parseInt(isChecked) && parseInt(statusOrder) <= parseInt(isChecked) ) {
                console.log('Two');

                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(statusOrder) >= parseInt(isChecked) ) {
                console.log('Three');
                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else {
                console.log('Four');
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(f) <= parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }


        }

        console.log('Final Status');
        console.log( finalS );

        objItem.staticStatus = document.getElementById(quoteId).innerHTML;

        var modalDetails = { title: 'Quote Status Update (' + objItem.quote_no + ')', component: 'modal-quote-status-update', mstate: true, params: {currentStatus: objItem.staticStatus, quoteId: quoteId, currentStatusStatic: objItem.status, object: objItem, statusList: finalS, quoteTotal: objItem.pricing_total } };
        this.$store.dispatch('fncPopulateStatusList');
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      fncMakeClickable( dateType ) {
        this.nonClickable = false;
        if( dateType == 'start' ) {
          var sDate = new Date(this.reportDate[0]);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          this.reportDate[0] = start_date;
        } else {
          var eDate = new Date(this.reportDate[1]);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          this.reportDate[1] = end_date;
        }
      },
      fncChangeQuotes( actionType, doReload = false ) {

        if( actionType == 'nonchange' ) {

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('quoteSetDays', this.quoteFilter);

          this.fncReloadFilters();

        } else if( actionType == true ) {

          var checkStart = new Date(this.reportDate[0]);
          var checkEnd = new Date(this.reportDate[1]);

          if( checkStart > checkEnd ) {
            alert('Start date must be bigger than the end date');
          } else {
            this.$store.commit('fncEmptyDashboard');
            this.$store.commit('fncIsLoaded', false);
            this.statuses = [];

            var newDates = [];
            for( var q in this.reportDate ) {
              if( this.reportDate[q].length == 10 ) {
                newDates.push( this.reportDate[q] );
              } else {
                newDates.push( this.reportDate[q].toISOString().split('T')[0] );
              }
            }

            this.reportDate = newDates;

            if (this.reportDate.length > 0) {
              var start_date = this.reportDate[0];
              if (start_date.length != 10) {
                start_date = this.reportDate[0].substr(0, 10);
              }

              if (start_date != localStorage.getItem("quote_start_date")) {
                start_date = start_date;
              }
            } else {
              start_date = '';
            }

            if (this.reportDate.length > 0) {
              var end_date = this.reportDate[1];
              if (end_date.length != 10) {
                end_date = this.reportDate[1].substr(0, 10);
              }

              if (end_date != localStorage.getItem("quote_end_date")) {
                end_date = end_date;
              } else {
                end_date = localStorage.getItem("quote_end_date");
              }
            } else {
              end_date = '';
            }

          }

          //this.fncSearchNewQuotes();

        } else if( actionType == false ) {
          // this.$store.commit( 'fncIsLoaded', false );

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('quoteSetDays', this.quoteFilter);

        }

        if( actionType != 'nonchange' ) {
          if( doReload == true ) {
            if (!isDateRangeSelection)
              this.fncSearchNewQuotes();
          } else {
            this.fncReloadFilters();
          }
        }

      },
      fncFilterLabel() {

        var sDate = new Date(this.reportStartDate);
        var eDate = new Date(this.reportEndDate);
        var diffDays = parseInt((eDate - sDate) / (1000 * 60 * 60 * 24), 10);

        // alert(diffDays);
        //this.quoteFilter = 99;

        if( ! this.dateChanged && this.quoteFilter != '' ) {
          if( this.reportStartDate == undefined ) {
            return 'View All Quotes';
          } else if( diffDays == 30 ) {
            return 'View Last 30 Days';
          } else if( diffDays == 60 ) {
            return 'View Last 60 Days';
          } else if( diffDays == 90 ) {
            return 'View Last 90 Days';
          } else if( diffDays == 7 ) {
            return 'View Last Week';
          } else if( diffDays > 150 ) {
            return 'View Last 6 Months';
          } else {
            return 'Set date range';
          }
        }
        return 'Set date range';

      },
      fncClearSearchTop() {
        this.search = '';
        this.$refs.searchField.lazyValue = '';
        localStorage.setItem('reportSearch','');
        localStorage.removeItem('secondTab')
        console.log('fncClearSearchTop')
        this.secondTab = null
        this.selectedStatus = null

        // this.$refs.searchQuoteField.lazyValue = null
        localStorage.setItem('reportSearchQuote',null);

        this.filterDrawer = false;
        //this.fncSearchQuoteLite();
        window.location.reload();
      },
      fncQuoteReportSearch(){
        localStorage.setItem('reportSearchQuote',JSON.stringify(this.searchQuoteReport));
        this.$router.push({path: '/reports/quote-reports-lite',query: 1});
        this.$router.go();

      },
      fncOnrangeChange()
      {
        //localStorage.setItem('reportIsDateChanged', false)
        //this.isDateChanged = false
        //this.fncSearchNewQuotes(true)
      },
      fncSearchNewQuotes( isSingleDate = false, hasTab = false, isClearFilter = false) {
        /** New clear filter**/
        if (isClearFilter === true){
          this.objVendor = ['all'];
          this.objDepartment = ['all'];
          this.objStore = ['all'];
          this.objOriginator = ['all'];
          this.objCustomerUser = ['all'];
          this.objStatus = ['all']
          this.objRegion = ['all'];
          this.objRep = ['all'];
          this.objKam = ['all'];
          this.objQuoteType = ['all'];
          this.objServiceType = ['all'];
          this.objcOriginator = ['all'];
          this.objProjects = ['all'];
          this.objCompany = ['all'];
        }
        this.secondTab = null

        localStorage.setItem('reportSearch',this.$refs.searchField.lazyValue);
        // localStorage.setItem('reportSearchQuote',JSON.stringify(this.$refs.searchQuoteField.lazyValue))
        if( isSingleDate ==  true ) {
          localStorage.setItem('quoteSetDays','');
        }/* else {
          localStorage.setItem('quoteSetDays',this.quoteFilter);
        }*/

        this.pagination.page = 1;

        if( this.reportDate.length != 2 ) {
          var start_date = '';
          var end_date = '';
        } else {
          var start_date = this.reportDate[0];
          if( start_date && start_date.length != 10 && start_date.length != 0 ) {
            var new_start_date = new Date(start_date);
            new_start_date.setDate(new_start_date.getDate() + 1);
            start_date = new_start_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_start_date', start_date);

          var end_date = this.reportDate[1];
          if( end_date.length != 10 && end_date.length != 0 ) {
            var new_end_date = new Date(end_date);
            new_end_date.setDate(new_end_date.getDate() + 1);
            end_date = new_end_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_end_date', end_date);
        }

        if( start_date == '' ) {
          start_date = '1900-01-01';
        }

        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }

        var reportDates = [];
        reportDates.push( start_date );
        reportDates.push( end_date );

        localStorage.setItem('quote_start_date', start_date);
        localStorage.setItem('quote_end_date', end_date);
        localStorage.setItem('reportDates', reportDates.toString());

        /* New */
        if (this.objOriginator != '' && this.objOriginator[0] != 'all' ) {
          localStorage.setItem('reportOriginators', JSON.stringify(this.objOriginator));
        } else {
          localStorage.removeItem('reportOriginators');
        }

        if (this.objStatus != '' && this.objStatus[0] != 'all' ) {
          localStorage.setItem('reportStatus', JSON.stringify(this.objStatus));
          this.secondTab = null
        }
        else {
          localStorage.removeItem('reportStatus');
        }

        if (this.objKam != '' && this.objKam[0] != 'all' ) {
          localStorage.setItem('reportKams', JSON.stringify(this.objKam));
        } else {
          localStorage.removeItem('reportKams');
        }

        if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
          localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
        } else {
          localStorage.removeItem('reportQuoteType');
        }

        if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
          localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
        } else {
          localStorage.removeItem('reportServiceType');
        }

        if (this.objcOriginator != '' && this.objcOriginator[0] != 'all' ) {
          localStorage.setItem('reportcOriginator', JSON.stringify(this.objcOriginator));
        } else {
          localStorage.removeItem('reportcOriginator');
        }

        if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
          localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
        } else {
          localStorage.removeItem('reportQuoteType');
        }

        if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
          localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
        } else {
          localStorage.removeItem('reportServiceType');
        }

        if (this.objCustomerUser != '' && this.objCustomerUser[0] != 'all') {
          localStorage.setItem('reportUsers', JSON.stringify(this.objCustomerUser));
        } else {
          localStorage.removeItem('reportUsers');
        }

        if (this.objVendor != '' && this.objVendor[0] != 'all') {
          localStorage.setItem('reportVendors', JSON.stringify(this.objVendor));
        } else {
          localStorage.removeItem('reportVendors');
        }

        if (this.objDepartment != '' && this.objDepartment[0] != 'all') {
          localStorage.setItem('reportDepartments', JSON.stringify(this.objDepartment));
        } else {
          localStorage.removeItem('reportDepartments');
        }

        if (this.objStore != '' && this.objStore[0] != 'all') {
          localStorage.setItem('reportStores', JSON.stringify(this.objStore));
        } else {
          localStorage.removeItem('reportStores');
        }

        if (this.objRegion != '' && this.objRegion[0] != 'all') {
          localStorage.setItem('reportRegions', JSON.stringify(this.objRegion));
        } else {
          localStorage.removeItem('reportRegions');
        }

        if (this.objRep != '' && this.objRep[0] != 'all') {
          localStorage.setItem('reportReps', JSON.stringify(this.objRep));
        } else {
          localStorage.removeItem('reportReps');
        }

        if (this.objProjects != '' && this.objProjects[0] != 'all') {
          localStorage.setItem('reportProjects', JSON.stringify(this.objProjects));
        } else {
          localStorage.removeItem('reportProjects');
        }

        if (this.objCompany != '' && this.objCompany[0] != 'all') {
          localStorage.setItem('reportCompany', JSON.stringify(this.objCompany));
        } else {
          localStorage.removeItem('reportCompany');
        }



        if( start_date == '' ) {
          start_date = '1900-01-01';
        }
        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }
        this.$router.push({path: '/reports/quote-reports-lite', query: 1});
        this.$router.go();

        /* End New */
        /*this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: 'null',
          date_to: 'null',
          date_to: 'null',
          region: 'null',
          status: 'null',
          originator: this.objOriginator,
          status: this.objStatus,
          store: this.objStore,
          customer: this.objCustomerUser,
          vendor: this.objVendor,
          department: this.objDepartment,
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: start_date,
          end_date: end_date,
          search: this.search
        });*/

        //this.filterDrawer = false;

        /*this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: 'null',
          date_to: 'null',
          region: 'null',
          status: 'null',
          originator: 'null',
          customer: 'null',
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: start_date,
          end_date: end_date
        });*/

        //this.nonClickable = true;

      },
      fncCheckSubDisplay( item ) {
        if( this.objAuthorize.manufacturer == '385889803' ) {
          if( item.id == 'total' || item.id == 'vat' ) {
            return false;
          } else {
            return item.checked;
          }
        } else {
          return item.checked;
        }
      },
      fncCheckOrderButton(status) {

        for ( var s in this.statusList ) {
          if (this.statusList[s].description == status) {
            if (this.statusList[s].is_checked == 'Yes' ) {
            //if (this.statusList[s].is_vendor == 'Yes' ) {
              return true;
            }
          }
        }
        return true;
      },
      fncClearSearch() {
        this.search = '';
        this.fncCustomReportSearch();
      },
      fncHasFilters() {
        if (this.filterActive == true ) {
          return 'hasFilters';
        } else {
          return '';
        }
      },
      fncIsLocked(status) {
        for (var s in this.statusList) {
          if (status == this.statusList[s].description) {
            if (this.statusList[s].is_lock == 'Yes' ) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      fncClearFilters() {

        var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];

        var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
        startDate = startDate.toISOString().split('T')[0];

        var newReportDate = [];
        newReportDate.push( startDate );
        newReportDate.push( dateToday );

        this.hasFilters = false;
        this.objCustomerRegion = '';
        this.objOriginator = ['all'];
        this.objStatus = ['all'];
        this.objCustomerCompany = ['all'];
        this.objCustomerUser = ['all'];
        this.objProject = ['all'];
        this.objSpecifier = ['all'];
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.startDate = '';
        this.endDate = '';
        this.search = '';
        // this.reportDate = '';
        this.reportDate = newReportDate;
        this.fncCustomReportSearch('');
        var snackDetails = { color: 'success', message: 'Quote Report filters have been cleared', display: true };
        this.$store.commit('setSnack', snackDetails);
        this.filterActive = false;
      },
      fncBlurAll() {
        if (this.$refs.originatorSelect != null) {
          this.originatorBlur = this.$refs.originatorSelect[0].isActive;
        }
        if (this.objCustomerCompany.length > 1 && this.$refs.companySelect != null ) {
          this.companyBlur = this.$refs.companySelect[0].isActive;
        }
        if (this.$refs.customerSelect != null) {
          this.customerBlur = this.$refs.customerSelect[0].isActive;
        }
        if (this.$refs.statusSelect != null) {
          this.statusBlur = this.$refs.statusSelect[0].isActive;
        }
        if (this.$refs.specifierSelect != null) {
          this.specifierBlur = this.$refs.specifierSelect[0].isActive;
        }
        if (this.$refs.projectSelect != null) {
          this.projectBlur = this.$refs.projectSelect[0].isActive;
        }
      },
      fncShowDateFilters() {

        if( this.reportDate[1] == '' && ( this.reportDate[0] != '' && this.reportDate[0] != undefined ) ) {

          var startDate = new Date(this.reportDate[0]);
          startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small> ALL after ' + ' ' + startDate + '</small>';
        } else if( this.reportDate[0] == '' && ( this.reportDate[1] != '' && this.reportDate[1] != undefined ) ) {

          var endDate = new Date(this.reportDate[1]);
          endDate.setDate(endDate.getDate() + 1);
          endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small> ALL up until ' + ' ' + endDate + '</small>';
        } else if( ( this.reportDate[0] == undefined || this.reportDate[1] == undefined  ) ) {
          return '<small>All Dates</small>';
        } else if( ( this.reportDate[0] == '' && this.reportDate[1] == '' ) ) {
          return '<small>All Dates</small>';
        } else {
          var startDate = new Date(this.reportDate[0]);
          startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

          var endDate = new Date(this.reportDate[1]);
          endDate.setDate(endDate.getDate() + 1);
          endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small>' + startDate + ' ~ ' + endDate + '</small>';
        }

      },
      fncShowOriginatorFilters() {
        var toReturn = '';
        var added = [];
        for (var o in this.objOriginator) {
          if (this.objOriginator[o] != 'all') {
            //var originatorList = this.fncSetFilters('originator');
            var quoteList = this.quoteList;
            for( var ro in quoteList ) {
              if (this.objOriginator[o] == quoteList[ro].originator && added.indexOf(quoteList[ro].originator) == -1) {
                added.push(quoteList[ro].originator);
                var objName = quoteList[ro].orig_name.split(' ');
                if( objName.length == 2 ) {
                  if( objName[0] == objName[1] ) {
                    toReturn += '<small>' +objName[0] + '<br /></small>';
                  } else {
                    toReturn += '<small>' +quoteList[ro].orig_name + '<br /></small>';
                  }
                } else {
                  toReturn += '<small>' +quoteList[ro].orig_name + '<br /></small>';
                }
              }
            }
          }
        }
        return toReturn;
      },
      fncShowVendorFilters() {
        var toReturn = '';
        var added = [];
        for (var v in this.objVendor) {
          if (this.objVendor[v] != 'all') {
            var vendorList = this.vendorList;
            for (var fo in vendorList) {
              if (this.objVendor[v] == vendorList[fo].id && added.indexOf(vendorList[fo].name) == -1) {
                added.push(vendorList[fo].name);
                toReturn += '<small>' + vendorList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      /*fncShowDepartmentFilters() {
        var toReturn = '';
        var added = [];
        for (var d in this.objDepartment) {
          if (this.objDepartment[d] != 'all') {
            var departmentList = this.fncSetFilters('department');
            for (var fo in departmentList) {
              if (this.objDepartment[d] == departmentList[fo].id && added.indexOf(departmentList[fo].name) == -1) {
                added.push(departmentList[fo].name);
                toReturn += '<small>' + departmentList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },*/
      fncShowStoreFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objStore) {
          if (this.objStore[s] != 'all') {
            /*var storeList = this.fncSetFilters('store');
            console.log( storeList );*/
            for (var fo in this.branchList) {
              if (this.objStore[s] == this.branchList[fo].code && added.indexOf(this.branchList[fo].code) == -1) {
                added.push(this.branchList[fo].code);
                toReturn += '<small>' + this.branchList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowDepartmentFilters() {
        var toReturn = '';
        var added = [];
        // var departmentList = this.fncSetFilters('department');
        for (var d in this.objDepartment) {
          if (this.objDepartment[d] != 'all') {
            for (var fo in this.departmentList) {
              if (this.objDepartment[d] == this.departmentList[fo].id && added.indexOf(this.departmentList[fo].name) == -1) {
                added.push(this.departmentList[fo].name);
                toReturn += '<small>' + this.departmentList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowStatusFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objStatus) {
          if (this.objStatus[s] != 'all') {
            var statusList = this.statusList;
            for( var sc in statusList ) {
              if (this.objStatus[s] == statusList[sc].description && added.indexOf(statusList[sc].description) == -1) {
                added.push(statusList[sc].description);
                toReturn += '<small>' + statusList[sc].description + '<br /></small>';
              }
            }
            /*for( var so in this.newReportFilters.status ) {
              if( this.objStatus[s] == so ) {
                toReturn += '<small>' + this.newReportFilters.status[so] + '<br /></small>';
              }
            }*/
          }
          /*if (this.objStatus[s] != 'all') {
            for (var fs in this.objQuoteFilters.status) {
              if (this.objQuoteFilters.status[fs] != undefined ) {
                if (this.objStatus[s] == this.objQuoteFilters.status[fs].name && added.indexOf(this.objQuoteFilters.status[fs].name) == -1) {
                  added.push(this.objQuoteFilters.status[fs].name);
                  toReturn += '<small>' + this.objQuoteFilters.status[fs].name + '<br /></small>';
                }
              }
            }
          }*/
        }
        return toReturn;
      },
      fncShowRepFilters() {

        var toDisplay = [];
        for( var i in this.repUsers ){
          if( this.objRep.indexOf(this.repUsers[i].id) != -1 ) {
            toDisplay.push( this.repUsers[i].fullname );
          }
        }
        if( toDisplay.length > 0 ) {
          var toReturn = '';
          for( var d in toDisplay ) {
            toReturn += '<small>'+toDisplay[d]+'</small><br />';
          }
        }
        return toReturn;
      },
      fncShowRegionFilters() {
        var toReturn = '';
        for( var r in this.objRegion ){
          toReturn += '<small>'+this.objRegion[r]+'</small><br />';
        }
        return toReturn;
      },
      fncShowProjectFilters() {
        var toReturn = '';
        var added = [];
        for (var p in this.objProject) {
          if (this.objProject[p] != 'all') {
            for (var fp in this.objQuoteFilters.projects) {
              if (this.objProject[p] == this.objQuoteFilters.projects[fp].name && added.indexOf(this.objQuoteFilters.projects[fp].name) == -1) {
                added.push(this.objQuoteFilters.projects[fp].name);
                toReturn += '<small>' + this.objQuoteFilters.projects[fp].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowSpecifierFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objSpecifier) {
          if (this.objSpecifier[s] != 'all') {
            for (var fs in this.objQuoteFilters.specifier) {
              if (this.objSpecifier[s] == this.objQuoteFilters.specifier[fs].name && added.indexOf(this.objQuoteFilters.specifier[fs].name) == -1) {
                added.push(this.objQuoteFilters.specifier[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.specifier[fs].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowCustomerUserFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objCustomerUser) {
          if (this.objCustomerUser[s] != 'all') {
            //var customerList = this.fncSetFilters('customer');
            var quoteList = this.quoteList;
            for( var sc in quoteList ) {
              if (this.objCustomerUser[s] == quoteList[sc].customer_id && added.indexOf(quoteList[sc].customer_id) == -1) {
                added.push(quoteList[sc].customer_id);
                var objName = quoteList[sc].customer_name.split(' ');
                if( objName.length == 2 ) {
                  if( objName[0] == objName[1] ) {
                    toReturn += '<small>' +objName[0] + '<br /></small>';
                  } else {
                    toReturn += '<small>' +quoteList[sc].customer_name + '<br /></small>';
                  }
                } else {
                  toReturn += '<small>' +quoteList[sc].customer_name + '<br /></small>';
                }
                //toReturn += '<small>' + customerList[sc].name + '<br /></small>';
              }
            }
          }
          /*if (this.objCustomerUser[s] != 'all') {
            for (var fs in this.objQuoteFilters.users) {
              if (this.objCustomerUser[s] == this.objQuoteFilters.users[fs].name && added.indexOf(this.objQuoteFilters.users[fs].name) == -1) {
                added.push(this.objQuoteFilters.users[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.users[fs].name + '<br /></small>';
              }
            }
          }*/
        }
        return toReturn;
      },
      fncShowCustomerCompanyFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objCustomerCompany) {
          if (this.objCustomerCompany[s] != 'all') {

            for (var fs in this.objQuoteFilters.company) {
              if (this.objCustomerCompany[s] == this.objQuoteFilters.company[fs].name && added.indexOf(this.objQuoteFilters.company[fs].name) == -1) {
                added.push(this.objQuoteFilters.company[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.company[fs].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncToggleFilters() {
        if (this.filterActive == true) {
          this.filterActive = false;
        } else {
          this.filterActive = true;
        }
      },
      fncLinkedQuotes( quote ) {

        this.$router.push({path: '/reports/quote-reports-lite?p=1&linked=' + quote.quote_no, query: 1});
        this.$router.go();

        /*this.$store.dispatch({
          type: 'fncPopulateQuoteLinks',
          id: quote.id,
          quote_no: quote.quote_no
        })

        var addedQuoteIds = [];
        var addedQuotes = [];*/

        /*console.log( this.quoteLinks );

        for( var q in this.quoteSearchList ) {
            if( ( this.quoteLinks.indexOf(quote.id) != -1 ) && addedQuoteIds.indexOf(this.quoteSearchList[q].id) == -1 ) {
              addedQuoteIds.push( this.quoteSearchList[q].id );
              addedQuotes.push( this.quoteSearchList[q] );
            }
        }

        console.log( addedQuotes );

        this.quotesLinked = true;
        this.$store.commit('fncSetQuoteListOutright', addedQuotes);*/

        //this.addedQuotes = this.quoteLinks;

        /*var addedQuoteIds = [];
        addedQuoteIds.push( quote.quote_no );

        var addedQuotes = [];
        addedQuotes.push( quote );

        for( var q in this.quoteSearchList ) {
          if( this.quoteSearchList[q].linked_quotes != null ) {
            var linkedQuotes = this.quoteSearchList[q].linked_quotes.split(',');
            if( ( linkedQuotes.indexOf(quote.quote_no) != -1 || linkedQuotes.indexOf(String(quote.quote_no)) != -1 ) && addedQuoteIds.indexOf(this.quoteSearchList[q].quote_no) == -1 ) {
              addedQuoteIds.push( this.quoteSearchList[q].id );
              addedQuotes.push( this.quoteSearchList[q] );
            }
          }
        }

        this.quotesLinked = true;
        this.$store.commit('fncSetQuoteListOutright', addedQuotes);*/
        //this.quoteSearchList = addedQuotes;

      },
      fncGoSaleOrder(quote) {
        this.$store.dispatch('fncProcessOrder', quote);
      },
      fncCheckStatusStatus(quote) {

        if( this.objAuthorize.manufacturer == '385889803' ) {
          /*var toReturn = false;
          for (var q in this.salesOrderStatusses) {
            if (this.salesOrderStatusses[q].quoteId == quote.id) {
              if (this.salesOrderStatusses[q].statusChangeable == false) {
                toReturn = true;
              }
            }
          }
          // we need to check for the statuses listed against this user
          if( toReturn == false ) {
            for( var s in this.statusList ) {
              if( this.statusList[s].description == quote.status ) {
                if( this.statusList[s].roles != null ) {
                  var statusRoles = this.statusList[s].roles.split(',');
                  if( statusRoles.indexOf(this.objAuthorize.roles[0]) == -1 ) {
                    toReturn = true;
                  }
                }
              }
            }
          }
          return toReturn;*/
          return false;
        } else {
          return false;
        }


      },
      setDates() {
        return window.localStorage.reportDates.split(',');
      },
      fncCheckSpecifier() {
        var isAll = false;
        if (this.objSpecifier.length > 1) {
          for (var s in this.objSpecifier) {
            if (this.objSpecifier[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objSpecifier.length == 1 && this.objSpecifier[0] == 'all') {
          isAll = true;
        }

        if (this.objSpecifier.length > 1 && isAll == true && this.objSpecifier[0] == 'all') {
          isAll = false;
        }

        if (this.objSpecifier.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objSpecifier = ['all'];
          localStorage.removeItem('reportSpecifiers');
        } else {
          var index = this.objSpecifier.indexOf('all');
          if (index > -1) {
            this.objSpecifier.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('specifier');
      },
      fncCheckProject() {
        var isAll = false;
        if (this.objProject.length > 1) {
          for (var p in this.objProject) {
            if (this.objProject[p] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objProject.length == 1 && this.objProject[0] == 'all') {
          isAll = true;
        }

        if (this.objProject.length > 1 && isAll == true && this.objProject[0] == 'all') {
          isAll = false;
        }

        if (this.objProject.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objProject = ['all'];
          localStorage.removeItem('reportProject');
        } else {
          var index = this.objProject.indexOf('all');
          if (index > -1) {
            this.objProject.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('project');
      },
      fncCheckOriginators() {

        var isAll = false;
        if (this.objOriginator.length > 1) {
          for (var o in this.objOriginator) {
            if (this.objOriginator[o] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objOriginator.length == 1 && this.objOriginator[0] == 'all') {
          isAll = true;
        }

        if (this.objOriginator.length > 1 && isAll == true && this.objOriginator[0] == 'all') {
          isAll = false;
        }

        if (this.objOriginator.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objOriginator = ['all'];
          localStorage.removeItem('reportOriginators');
        } else {
          var index = this.objOriginator.indexOf('all');
          if (index > -1) {
            this.objOriginator.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('originators');
      },
      fncCheckVendor() {

        var isAll = false;
        if (this.objVendor.length > 1) {
          for (var v in this.objVendor) {
            if (this.objVendor[v] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objVendor.length == 1 && this.objVendor[0] == 'all') {
          isAll = true;
        }

        if (this.objVendor.length > 1 && isAll == true && this.objVendor[0] == 'all') {
          isAll = false;
        }

        if (this.objVendor.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objVendor = ['all'];
          localStorage.removeItem('reportVendors');
        } else {
          var index = this.objVendor.indexOf('all');
          if (index > -1) {
            this.objVendor.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('vendors');
      },
      fncCheckDepartment() {

        var isAll = false;
        if (this.objDepartment.length > 1) {
          for (var d in this.objDepartment) {
            if (this.objDepartment[d] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objDepartment.length == 1 && this.objDepartment[0] == 'all') {
          isAll = true;
        }

        if (this.objDepartment.length > 1 && isAll == true && this.objDepartment[0] == 'all') {
          isAll = false;
        }

        if (this.objDepartment.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objDepartment = ['all'];
          localStorage.removeItem('reportDepartments');
        } else {
          var index = this.objDepartment.indexOf('all');
          if (index > -1) {
            this.objDepartment.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('departments');
      },
      fncCheckStoreDrop() {

        var isAll = false;
        if (this.objStore.length > 1) {
          for (var d in this.objStore) {
            if (this.objStore[d] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStore.length == 1 && this.objStore[0] == 'all') {
          isAll = true;
        }

        if (this.objStore.length > 1 && isAll == true && this.objStore[0] == 'all') {
          isAll = false;
        }

        if (this.objStore.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objStore = ['all'];
          localStorage.removeItem('reportStores');
        } else {
          var index = this.objStore.indexOf('all');
          if (index > -1) {
            this.objStore.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('stores');
      },
      fncCheckUser() {
        var isAll = false;
        if (this.objCustomerUser.length > 1) {
          for (var c in this.objCustomerUser) {
            if (this.objCustomerUser[c] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objCustomerUser.length == 1 && this.objCustomerUser[0] == 'all') {
          isAll = true;
        }

        if (this.objCustomerUser.length > 1 && isAll == true && this.objCustomerUser[0] == 'all') {
          isAll = false;
        }

        if (this.objCustomerUser.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objCustomerUser = ['all'];
          localStorage.removeItem('reportUsers');
        } else {
          var index = this.objCustomerUser.indexOf('all');
          if (index > -1) {
            this.objCustomerUser.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('companyuser');
      },
      fncCheckCompany() {
        var isAll = false;
        if (this.objCustomerCompany.length > 1) {
          for (var c in this.objCustomerCompany) {
            if (this.objCustomerCompany[c] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objCustomerCompany.length == 1 && this.objCustomerCompany[0] == 'all') {
          isAll = true;
        }

        if (this.objCustomerCompany.length > 1 && isAll == true && this.objCustomerCompany[0] == 'all') {
          isAll = false;
        }

        if (this.objCustomerCompany.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objCustomerCompany = ['all'];
          localStorage.removeItem('reportCompanies');
        } else {
          var index = this.objCustomerCompany.indexOf('all');
          if (index > -1) {
            this.objCustomerCompany.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('company');
      },
      fncCheckStatus() {

        var isAll = false;
        if (this.objStatus.length > 1) {
          for (var s in this.objStatus) {
            if (this.objStatus[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStatus.length == 1 && this.objStatus[0] == 'all') {
          isAll = true;
        }

        if (this.objStatus.length > 1 && isAll == true && this.objStatus[0] == 'all') {
          isAll = false;
        }

        if (this.objStatus.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objStatus = ['all'];
          localStorage.removeItem('reportStatus');
        } else {
          var index = this.objStatus.indexOf('all');
          if (index > -1) {
            this.objStatus.splice(index, 1);
          }
        }

        this.fncCustomReportSearch('status');
      },
      fncUpper( string ) {
        return string.toUpperCase();
      },
      fncCustomReportSearch(type) {

        if( type == 'search' && this.search == '' ) {
          this.fncSearchNewQuotes();
        } else {
          if (this.$refs.dateSelect != null ) {
            this.$refs.dateSelect[0].closePopup();
          }

          if (
            (this.objCustomerRegion.length > 0 && this.objCustomerRegion[0] != 'all') ||
            (this.objOriginator.length > 0 && this.objOriginator[0] != 'all') ||
            (this.objStatus.length > 0 && this.objStatus[0] != 'all') ||
            (this.objCustomerCompany.length > 0 && this.objCustomerCompany[0] != 'all') ||
            (this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all') ||
            (this.objProject.length > 0 && this.objProject[0] != 'all') ||
            (this.objSpecifier.length > 0 && this.objSpecifier[0] != 'all') ||
            (this.objDepartment.length > 0 && this.objDepartment[0] != 'all') ||
            (this.objStore.length > 0 && this.objStore[0] != 'all') ||
            (this.objVendor.length > 0 && this.objVendor[0] != 'all')) {
            this.hasFilters = true;
          } else {
            this.hasFilters = false;
            type = '';
          }

          if( this.hasFilters == false && this.reportDate != '' ) {
            this.hasFiltersDateOnly = true;
          }

          if ( type == '' ) {
            var newPush = [];
            newPush.push(type);
            localStorage.setItem('searchOrder', JSON.stringify(newPush));
          } else if (window.localStorage.searchOrder == null || window.localStorage.searchOrder == 'undefined') {
            var newPush = [];
            newPush.push(type);
            localStorage.setItem('searchOrder', JSON.stringify(newPush));
          } else {
            var oldPush = JSON.parse(window.localStorage.searchOrder);

            var checkEmpty = '';
            if (type == 'search') {
              checkEmpty = this.search;
            } else if (type == 'date') {
              checkEmpty = this.reportDate;
            } else if (type == 'specifier') {
              checkEmpty = this.objSpecifier;
            } else if (type == 'project') {
              checkEmpty = this.objProject;
            } else if (type == 'originators') {
              checkEmpty = this.objOriginator;
            } else if (type == 'status') {
              checkEmpty = this.objStatus;
            } else if (type == 'user') {
              checkEmpty = this.objCustomerUser;
            } else if (type == 'company') {
              checkEmpty = this.objCustomerCompany;
            } else if (type == 'vendors') {
              checkEmpty = this.objVendor;
            } else if (type == 'departments') {
              checkEmpty = this.objDepartment;
            } else if (type == 'stores') {
              checkEmpty = this.objStore;
            }

            if (oldPush.indexOf(type) == -1) {
              oldPush.push(type);
              localStorage.setItem('searchOrder', JSON.stringify(oldPush));
            } else if (checkEmpty == '') {
              oldPush = oldPush.filter(function (e) { return e !== type });
              localStorage.setItem('searchOrder', JSON.stringify(oldPush));
            }

          }

          console.log('Three');
          // set the vars here call original object
          localStorage.setItem('reportSearch', this.search);

          if (this.reportDate != '') {
            localStorage.setItem('reportDates', this.reportDate.toString());
          } else {
            localStorage.removeItem('reportDates');
          }

          if (this.objOriginator != '' && this.objOriginator[0] != 'all' ) {
            localStorage.setItem('reportOriginators', JSON.stringify(this.objOriginator));
          } else {
            localStorage.removeItem('reportOriginators');
          }

          if (this.objStatus != '' && this.objStatus[0] != 'all' ) {
            localStorage.setItem('reportStatus', JSON.stringify(this.objStatus));
          } else {
            localStorage.removeItem('reportStatus');
          }

          if (this.objKam != '' && this.objKam[0] != 'all' ) {
            localStorage.setItem('reportKams', JSON.stringify(this.objKam));
          } else {
            localStorage.removeItem('reportKams');
          }

          if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
            localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
          } else {
            localStorage.removeItem('reportQuoteType');
          }

          if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
            localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
          } else {
            localStorage.removeItem('reportServiceType');
          }

          if (this.objcOriginator != '' && this.objcOriginator[0] != 'all' ) {
            localStorage.setItem('reportcOriginator', JSON.stringify(this.objcOriginator));
          } else {
            localStorage.removeItem('reportcOriginator');
          }

          if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
            localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
          } else {
            localStorage.removeItem('reportQuoteType');
          }

          if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
            localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
          } else {
            localStorage.removeItem('reportServiceType');
          }

          if (this.objProject != '' && this.objProject[0] != 'all') {
            localStorage.setItem('reportProject', JSON.stringify(this.objProject));
          } else {
            localStorage.removeItem('reportProject');
          }

          if (this.objCustomerUser != '' && this.objCustomerUser[0] != 'all') {
            localStorage.setItem('reportUsers', JSON.stringify(this.objCustomerUser));
          } else {
            localStorage.removeItem('reportUsers');
          }

          if (this.objCustomerCompany != '' && this.objCustomerCompany[0] != 'all') {
            localStorage.setItem('reportCompanies', JSON.stringify(this.objCustomerCompany));
          } else {
            localStorage.removeItem('reportCompanies');
          }

          if (this.objSpecifier != '' && this.objSpecifier[0] != 'all') {
            localStorage.setItem('reportSpecifiers', JSON.stringify(this.objSpecifier));
          } else {
            localStorage.removeItem('reportSpecifiers');
          }

          if (this.objVendor != '' && this.objVendor[0] != 'all') {
            localStorage.setItem('reportVendors', JSON.stringify(this.objVendor));
          } else {
            localStorage.removeItem('reportVendors');
          }

          if (this.objDepartment != '' && this.objDepartment[0] != 'all') {
            localStorage.setItem('reportDepartments', JSON.stringify(this.objDepartment));
          } else {
            localStorage.removeItem('reportDepartments');
          }

          if (this.objStore != '' && this.objStore[0] != 'all') {
            localStorage.setItem('reportStores', JSON.stringify(this.objStore));
          } else {
            localStorage.removeItem('reportStores');
          }

          // HERE

          this.$store.commit({
            type: 'setQuoteList',
            quotes: this.quoteList,
            departments: this.departmentList,
            branches: this.branchList,
            loggedUser: this.objAuthorize
          })
        }

      },
      fncGetWidth(columnId) {
        var setWidth = '';
        for (var k in this.objQuoteSettings) {
          if (this.objQuoteSettings[k].id == columnId) {
            setWidth = this.objQuoteSettings[k].width;
          }
          if (setWidth == 'auto') {
            setWidth = '165px';
            if (this.objQuoteSettings[k].label.toLowerCase() == 'preferred follow up method') {
              setWidth = '275px';
            } else if (this.objQuoteSettings[k].label == 'Customer Email' || this.objQuoteSettings[k].label == 'Customer Name' || this.objQuoteSettings[k].label == 'Originator Name') {
              setWidth = '250px';
            } else if (this.objQuoteSettings[k].label == 'Status') {
              setWidth = '500px';
            } else if (this.objQuoteSettings[k].label == 'Quote Date' || this.objQuoteSettings[k].label == 'Process Order') {
              setWidth = '200px';
            } else if (this.objQuoteSettings[k].label == 'Company Name' || this.objQuoteSettings[k].label == 'Quote Type') {
              setWidth = '225px';
            } else if (this.objQuoteSettings[k].label == 'Customer Type') {
              setWidth = '175px';
            } else if (this.objQuoteSettings[k].label == 'Store') {
              setWidth = '175px';
            } else if (this.objQuoteSettings[k].label == 'Installation Description' || this.objQuoteSettings[k].label == 'Cancellation Reason') {
              setWidth = '250px';
            } else if ( this.objQuoteSettings[k].label == 'Commercial KAM' || this.objQuoteSettings[k].label == 'Commercial Originator') {
              setWidth = '250px';
            } else if (this.objQuoteSettings[k].label == 'Purchase Order Number' || this.objQuoteSettings[k].label == 'Calculator') {
              setWidth = '250px';
            } else if( this.objQuoteSettings[k].label == 'Responsible Rep' || isNaN(columnId) == false || this.objQuoteSettings[k].label == 'Customer Recipient' || this.objQuoteSettings[k].label == 'Vendor Recipient' ) {
              setWidth = '350px';
            }
          }
        }
        return setWidth;
      },
      fncGetDepartment( objItem, key ) {

        var returnDepartment = 'N/A';

        var departmentName = [];

        var hasDepartment = false;
        if( objItem.pCodes ) {
          var productCodes = objItem.pCodes.split(',');
        } else {
          var productCodes = [];
        }


        if( this.surveyList[objItem.id] != undefined && this.surveyList[objItem.id] != null ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].id == this.surveyList[objItem.id] ) {
              returnDepartment = this.departmentList[d].name;
              hasDepartment = true;
            }
          }
        }

        if( productCodes.length > 0 && hasDepartment == false ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null ) {
              if( this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].name;
                      hasDepartment = true;
                      return returnDepartment;
                    }
                  }
                }
              }
            }
          }
        }

        if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
          var departmentRanges = this.departmentList;
          var filteredQuotes = [];
          var quoteRanges = objItem.range_id.split(',');
          for( var d in departmentRanges ) {
            for( var qr in quoteRanges ) {
              for( var dr in departmentRanges[d].ranges ) {
                if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                  departmentName.push( departmentRanges[d].name );
                }
              }
            }
          }
          var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
          if( uniqueDepartment.length == 0 ) {
            if( objItem.originator_department != '' && objItem.originator_department != null ) {
              /*for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.originator_department ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }*/
            } else {
              if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                /*for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.departmentUser ) {
                    returnDepartment = this.departmentList[d].name;
                    hasDepartment = true;
                  }
                }*/
                return returnDepartment;
              } else {
                var productCodes = [];

                if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                  var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                  if( line_item_data.length > 0 ) {
                    for( var l in line_item_data ) {
                      if( typeof line_item_data[l] == 'string' ) {
                        var lineObj = line_item_data[l];
                      } else {
                        var lineObj = JSON.parse( line_item_data[l]);
                      }
                      //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                      if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                        productCodes.push(lineObj.product_code);
                      }
                    }
                  }
                }

                if( productCodes.length > 1 ) {
                  returnDepartment = 'N/A';
                  hasDepartment = true;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].name;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else if( uniqueDepartment.length > 1 ) {
            /*if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
              hasDepartment = true;
            }*/
          } else {
            returnDepartment = uniqueDepartment[0];
            hasDepartment = true;
          }
        }

        /*if( hasDepartment == false ) {
          if( objItem.originator_department != '' && objItem.originator_department != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == objItem.originator_department ) {
                returnDepartment = this.departmentList[d].name;
              }
            }
          } else {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
            }
          }
        }*/
        return returnDepartment;
      },
      fncGetDepartmentId( objItem, key ) {

        var returnDepartment = 'N/A';

        var departmentName = [];

        // check for product code first
        /*var productCodes = [];
        var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
        if( line_item_data.length > 0 ) {
          for( var l in line_item_data ) {
            var lineObj = JSON.parse( line_item_data[l] );
            if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
              productCodes.push(lineObj.product_code);
            }
          }
        }*/

        var hasDepartment = false;
        var productCodes = objItem.pCodes.split(',');

        if( productCodes.length > 0 ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null ) {
              if( this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].id;
                      hasDepartment = true;
                      return returnDepartment;
                    }
                  }
                }
              }
            }
          }
        }

        if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
          var departmentRanges = this.departmentList;
          var filteredQuotes = [];
          var quoteRanges = objItem.range_id.split(',');
          for( var d in departmentRanges ) {
            for( var qr in quoteRanges ) {
              for( var dr in departmentRanges[d].ranges ) {
                if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                  departmentName.push( departmentRanges[d].id );
                }
              }
            }
          }
          var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
          if( uniqueDepartment.length == 0 ) {
            if( objItem.originator_department != '' && objItem.originator_department != null ) {
              /*for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.originator_department ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }*/
            } else {
              if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                /*for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.departmentUser ) {
                    returnDepartment = this.departmentList[d].name;
                    hasDepartment = true;
                  }
                }*/
                return returnDepartment;
              } else {
                var productCodes = [];

                if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                  var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                  if( line_item_data.length > 0 ) {
                    for( var l in line_item_data ) {
                      if( typeof line_item_data[l] == 'string' ) {
                        var lineObj = line_item_data[l];
                      } else {
                        var lineObj = JSON.parse( line_item_data[l]);
                      }
                      //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                      if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                        productCodes.push(lineObj.product_code);
                      }
                    }
                  }
                }

                if( productCodes.length > 1 ) {
                  returnDepartment = 'N/A';
                  hasDepartment = true;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].id;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else if( uniqueDepartment.length > 1 ) {
            /*if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
              hasDepartment = true;
            }*/
          } else {
            returnDepartment = uniqueDepartment[0];
            hasDepartment = true;
          }
        }

        /*if( hasDepartment == false ) {
          if( objItem.originator_department != '' && objItem.originator_department != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == objItem.originator_department ) {
                returnDepartment = this.departmentList[d].name;
              }
            }
          } else {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
            }
          }
        }*/
        return returnDepartment;
      },
      fncFormatColumn(objItem, key) {
        switch (key) {
          /*case 'customerRecipient':
            if( objItem.customer_recipient != '' ) {
              return objItem.customer_recipient;
            } else {
              return 'N/A';
            }*/
          case 'poNumbers':

            var poSplit = objItem.po_numbers.split(',');
            if( poSplit.length == 0 ) {
              return 'N/A';
            } else {
              var newPo = [];
              for( var p in poSplit ) {
                if( poSplit[p] != '' && poSplit[p] != '0' ) {
                  newPo.push(poSplit[p]);
                }
              }
              if( newPo.length != 0 ) {
                return newPo.join(', ');
              } else {
                return 'N/A';
              }
            }
          case 'addressType':
            if( objItem.collect_address != '0' ) {
              return 'Collect'
            } else if( objItem.delivery_address != '0' ) {
              return 'Deliver'
            } else {
              return 'N/A';
            }
          case 'appointmentDate':
            if( objItem.process_data != null && objItem.process_data != 'null' ) {
              var processData = JSON.parse( objItem.process_data );
              for( var f in processData.tabs ) {
                for( var fd in processData.tabs[f] ) {
                    for( var td in processData.tabs[f].form ) {
                      if( processData.tabs[f].form[td].label == 'Preferred Date' ) {
                        if( processData.tabs[f].form[td].value != '' ) {
                          return processData.tabs[f].form[td].value;
                        } else {
                          return 'N/A';
                        }
                      }
                    }
                }
              }
            } else {
              return 'N/A';
            }
          case 'appointmentTime':
            if( objItem.process_data != null && objItem.process_data != 'null' ) {
              var processData = JSON.parse( objItem.process_data );
              for( var f in processData.tabs ) {
                for( var fd in processData.tabs[f] ) {
                  for( var td in processData.tabs[f].form ) {
                    if( processData.tabs[f].form[td].label == 'Preferred Time' ) {
                      if( processData.tabs[f].form[td].value != '' ) {
                        return processData.tabs[f].form[td].value;
                      } else {
                        return 'N/A';
                      }
                    }
                  }
                }
              }
            } else {
              return 'N/A';
            }
          case 'quoteRegion':
            /*if( objItem.spec ) {
              var regionSplit = objItem.spec.split("<span class='quoteRegion'>");
              if( regionSplit.length > 1 ) {
                var regionSplitName = regionSplit[1].split('</span>');
                return regionSplitName[0];
              } else {
                return 'N/A';
              }
            } else {
              return 'N/A';
            }*/
            return this.fncCheckStoreLocation(objItem.store_name);
            break;
          case 'customerRejectReason':
            if( objItem.audit_data == '' || objItem.audit_data == null || objItem.audit_data == 'null' ) {
              return 'N/A';
            } else {
              var cancelReasons = ["Cost", "Not Interested Anymore", "Unhappy With The Service", "Was Just Checking Cost"];
              var objReasons = objItem.audit_data.split(',');
              for( var r in objReasons ){
                if( cancelReasons.indexOf( objReasons[r] ) != -1 ) {
                  return objReasons[r];
                }
              }
              //return objItem.audit_data;
              return 'N/A';
            }
          case 'quote_date':

            var options = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "numeric",
              minute: "numeric",
              hour12: false
            };

            var newDate = new Date( Date.parse(objItem[key] + ' UTC') );
            var dateString = newDate.toLocaleString("en", options);
            var objDate = dateString.split(',');

            var newDate = objDate[0].split('/');

            var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

            return strDate;
          case 'onsiteTime':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_on_site == 'Yes' || this.statusList[s].fs_on_site == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].time;
              }
            }
            return toReturn;
            break;
          case 'jobCompleteDate':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_job_complete == 'Yes' || this.statusList[s].fs_job_complete == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].time;
              }
            }
            return toReturn;
            break;
          case 'cancellationReason':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_job_cancelled == 'Yes' || this.statusList[s].fs_job_cancelled == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].data;
              }
            }
            return toReturn;
            break;
          case 'status_change_reason':
            return '<span id="reason_'+objItem.id+'">' + objItem.status_change_reason + '</span>';
            break;
          case 'customerRating':
            if( objItem.rating == '0' ) {
              return 'N/A';
            } else {
              return objItem.rating;
            }
            break;
          case 'installationDate':
            var lineData = objItem.product_codes;
            var installationDate = 'N/A';
              if( objItem.product_codes && lineData.indexOf('installation_appointment_date_start') != -1 ) {
                var timeSplit = lineData.split('installation_appointment_date_start');
                var newSplit = timeSplit[1].replace(/"/g, "");
                    newSplit = newSplit.replace(/'/g, "");
                    newSplit = newSplit.replace(/:/g, "");
                    newSplit = newSplit.replace(/\//g,'')
                    newSplit = newSplit.split('\\');
                installationDate = newSplit[2];
                var onjInstallDate = installationDate.split(',');
                installationDate = onjInstallDate[ onjInstallDate.length - 1 ];
              }
              return installationDate;
            break;
          case 'installationDescription':
            var lineData = objItem.product_codes;
            var installationDescription = 'N/A';
            if( objItem.product_codes && lineData.indexOf('installation_product_description_1') != -1 ) {
              var timeSplit = lineData.split('installation_product_description_1');
              var newSplit = timeSplit[1].replace(/"/g, "");
              newSplit = newSplit.replace(/'/g, "");
              newSplit = newSplit.replace(/:/g, "");
              newSplit = newSplit.replace(/\//g,'')
              newSplit = newSplit.split('\\');
              installationDescription = newSplit[2];
            }
            return installationDescription;
            break;
          case 'serviceType':
            if( objItem.service_type == '3' ) {
              return 'Commercial';
            } else if( objItem.service_type == '1' ) {
              return 'Assisted Service';
            } else if( objItem.service_type == '2' ) {
                return 'Self Service';
            } else {
              return 'Unknown';
            }
            break;
          case 'soNumber':
            if( objItem.sales_order_number != null && objItem.sales_order_number != undefined ) {
              return objItem.sales_order_number
            } else {
              return 'N/A';
            }
            break;
          case 'department':
            //return this.fncGetDepartment( objItem, key );
            return objItem.departmentName;
            break;
          case 'quote_no':
            return '<span class="quoteSettings"><strong style="margin-top: 0px !important;">' + objItem[key] + '</strong></span>&nbsp;&nbsp;';
            break;
          case 'sub_total':
            return '<strong>' + this.fncFixedRand(objItem.pricing_subtotal, objItem.override_currency_sym) + '</strong>';
            break;
          case 'vat':
            return '<strong>' + this.fncFixedRand(objItem.pricing_vat, objItem.override_currency_sym) + '</strong>';
            break;
          case 'total':
            return '<strong>' + this.fncFixedRand(objItem.pricing_total, objItem.override_currency_sym) + '</strong>';
            break;
          case 'discount_value':
            return this.fncFixedRand(objItem.discount_val, objItem.override_currency_sym);
            break;
          case 'pre_discount_total':
            return this.fncFixedRand(objItem.discount_val, objItem.override_currency_sym);
            break;
          case 'customer_region':
            return this.fncCheckNull(objItem.customer_region);
            break;
          case 'originator_region':
            return this.fncCheckNull(objItem.originator_region);
            break;
          case 'status':
            //  return '<strong class="cursor">&nbsp;' + objItem.status + '</strong>';
            break;
          case 'process_order':
            //return 'Meh';
            //  return '<strong class="cursor">&nbsp;' + objItem.status + '</strong>';
            break;
          case 'orig_name':
            if( objItem.orig_name != '' && objItem.orig_name!= null ) {
              var origName = objItem.orig_name.split(' ');
              if( origName.length == 2 ) {
                if( origName[0] == origName[1] ) {
                  return '<strong class="cursor">' + origName[0] + '</strong>';
                } else {
                  return '<strong class="cursor">' + objItem.orig_name + '</strong>';
                }
              } else {
                return '<strong class="cursor">' + objItem.orig_name + '</strong>';
              }
            } else {
              return '<strong class="cursor">N/A</strong>';
            }
            break;
          case 'store_name':
            return this.fncCheckStore(objItem.store_name);
            break;
          case 'responsible_representative':

            if( this.objAuthorize.manufacturer != '385889803' ) {
              var resRep = objItem.responsible_representative;
              if ( resRep == 'N/A' ) {
                resRep = 'None';
              }

              if (resRep.length >  24 ) {
                return '<strong class="cursor">' + resRep.substr(0,24) + '...</strong>';
              } else {
                return '<strong class="cursor">' + resRep + '</strong>';
              }
            } else {
              return '';
            }
            //return '<strong class="cursor">'+objItem.responsible_representative+'</strong>';
            //return '<strong class="cursor">&nbsp;Click to View Reps</strong>';
            break;
          case 'customer_name':
            if (objItem.customer_name == null ) {
              return 'N/A';
            } else {

              var toSplit = 'N/A';
              var userSplit = objItem.customer_name.split(' - ');
              if (userSplit.length == 1) {
                toSplit = userSplit[0];
                //return '<strong class="cursor">' + userSplit[0] + '</strong>';
              } else if (userSplit.length == 2) {
                toSplit = userSplit[1];
                //return '<strong class="cursor">' + userSplit[1] + '</strong>';
              } else if (userSplit.length == 3) {
                toSplit = userSplit[2];
                //return '<strong class="cursor">' + userSplit[2] + '</strong>';
              }

              var cusName = toSplit.split(' ');
              if( cusName.length == 2 ) {
                if( cusName[0] == cusName[1] ) {
                  return '<strong class="cursor">' + cusName[0] + '</strong>';
                } else {
                  return '<strong class="cursor">' + toSplit + '</strong>';
                }
              } else {
                return '<strong class="cursor">' + toSplit + '</strong>';
              }

            }
            break;
          case 'company_name':
            if( objItem.company_name != 'None' ) {
              return objItem.company_name;
            } else if (objItem.customer_name != null ) {
              var userSplit = objItem.customer_name.split(' - ');
              if (userSplit.length > 1) {
                return userSplit[0];
              } else {
                return 'None';
              }
            } else {
              return 'None';
            }
            break;
          case 'survey_type':
            // this.surveyListQuotes[]
            if( this.surveyListQuotes[objItem.id] == '1' ) {
              return 'Contact Customer';
            } else if( this.surveyListQuotes[objItem.id] == '2' ) {
              return 'Request Quote';
            } else if( this.surveyListQuotes[objItem.id] == '3' ) {
              return 'Callout Request';
            } else if( this.surveyListQuotes[objItem.id] == '4' ) {
              return 'Callout Conversion';
            } else if( this.surveyListQuotes[objItem.id] == '5' ) {
              return 'Request Calculator';
            } else {
              return 'N/A';
            }
            break;
          case 'customerTelephone':
              if( objItem.customer_telephone != '' ) {
                return objItem.customer_telephone;
              } else {
                return 'N/A';
              }
            break;
          case 'customerEmail':
            if( objItem.customer_email != '' ) {
              return objItem.customer_email;
            } else {
              return 'N/A';
            }
            break;
          case 'quoteType':

            if( objItem.product_codes.includes('installation_lookup_service_ref') ) {
              return 'Lookup Service';
            } else if( this.surveyList[objItem.id] != undefined ) {
              return 'Service Form';
            }
            return 'Calculator';
            break;
          case 'calculator':
            if( this.surveyList[objItem.id] != undefined ) {
              return 'Service Form';
            } else if( objItem.item_range != '' ) {
              return objItem.item_range;
            } else {
              return 'N/A';
            }
            break;
          case 'kamRegion':

            var specData = objItem.spec;
            var kamRegion = 'N/A';

            if( objItem.spec && specData.indexOf("<span class='quoteRegion'>") != -1 ) {

              var regionSplit = specData.split("<span class='quoteRegion'>");
              if( regionSplit.length > 1 ) {
                var regionName = regionSplit[1].split('</span>');
                if( regionName.length > 1 ) {
                  kamRegion = regionName[0];
                }
              }
            }
            return kamRegion;
            break;
          case 'orig_type':
            if( objItem[key] == 'Manufacturer User' && this.objAuthorize.manufacturer == '385889803' ) {
              return 'Builders User';
            } else {
              return objItem[key];
            }
            break;
           case 'linkedQuotes':
             return objItem['linked_quotes'];
             break;
          default:
            return objItem[key];
            break;
        }
      },
      fncCheckStore( storeCode ) {
        for( var b in this.branchList ) {
          if( this.branchList[b].code == storeCode ) {
            return this.branchList[b].name;
          }
        }
        return storeCode;
      },
      fncCheckStoreLocation( storeCode ) {
        for( var b in this.branchList ) {
          if( this.branchList[b].code == storeCode ) {
            return this.branchList[b].locationName;
          }
        }
        return storeCode;
      },
      fncFixedRand(val, currencySymbol) {
        if( val == '0' ) {
          return '<span class="floatRight">PENDING</span>';
        } else {
          if (currencySymbol == '' || currencySymbol == null) {
            currencySymbol = 'R';
          }
          return '<span class="floatRight">' + currencySymbol + parseFloat(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span>';
        }
      },
      fncCheckNull(val) {
        if (val === null) {
          return 'N/A';
        } else {
          return '<span class="cursor">' + val + '</span>';
        }
      },
      fncShowColumn(col) {
      },
      fncEditStatus(objItem, key) {
        if (key === 'originator_region' ) {
          this.$store.dispatch('fncGetUserInfo', objItem.customer);
          var modalDetails = { title: 'Originator Region (' + objItem.orig_name + ')', component: 'modal-user-info', mstate: true, params: { type: 'orig_region' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'customer_region') {
          var cName = '';
          var customer = objItem.customer_name.split('-');
          if (customer.length == 1) {
            cName = customer[0];
          } else {
            cName = customer[1];
          }
          this.$store.dispatch('fncGetUserInfo', objItem.customer);
          var modalDetails = { title: 'Customer Region (' + cName + ')', component: 'modal-user-info', mstate: true, params: { type: 'customer_region' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'status') {
          this.$store.dispatch('fncGetQuoteHistory', objItem.id);
          var modalDetails = { title: 'Status History (' + objItem.quote_no + ')', component: 'modal-quote-history', mstate: true, params: {} };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'orig_name') {
          this.$store.dispatch('fncGetUserInfo', objItem.originator);
          var modalDetails = { title: 'User Information - ' + objItem.orig_name, component: 'modal-user-info', mstate: true, params: { type: 'orig' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'customer_name') {
          var cName = '';
          var customer = objItem.customer_name.split('-');
          if ( customer.length == 1 ) {
            cName = customer[0];
          } else {
            cName = customer[1];
          }
          this.$store.dispatch('fncGetUserInfo', objItem.customer_id);
          var modalDetails = { title: 'User Information - ' + cName, component: 'modal-user-info', mstate: true, params: { type: 'customer' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'responsible_representative') {
          var modalDetails = { title: 'Link / Unlink Users ( ' + objItem.quote_no+' )', component: 'modal-quote-link-users', mstate: true, params: { quoteId: objItem } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.$store.dispatch('fncAvailableReps', objItem.customer_id);
        } else if (key === 'linkedQuotes') {

          alert('Test');
          /*var modalDetails = { title: 'Link / Unlink Users ( ' + objItem.quote_no+' )', component: 'modal-quote-link-users', mstate: true, params: { quoteId: objItem } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.$store.dispatch('fncAvailableReps', objItem.customer_id);*/
        }
      },
      fncEditStatusPopup(item) {

        this.$store.dispatch({
          type: 'fncGetLiteStatus',
          data: item,
          list: true
        })
      },
      fncDistibuteQuote( objItem, customerEmail ) {
        var modalDetails = { title: 'Distribute Quote', component: 'modal-distribute-quote', mstate: true, params: {quoteId: objItem, customerEmail: customerEmail} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncQuoteSettings(quoteId, quoteNo,item) {

        this.$store.dispatch({
          type: 'fncQuoteSettings',
          quoteId: quoteId,
          quoteNo: quoteNo,
          data:item,
        })
        //this.$store.dispatch('fncQuoteSettings', quoteId);
      },
      fncForex(quoteId, quoteNo, currencyType) {
        //this.$store.dispatch('fncGetOriginalForex', currencyType );
        var modalDetails = { title: 'Change Currency - '+quoteNo, component: 'modal-quote-forex', mstate: true, params: { quoteId: quoteId, currencyType: currencyType } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditQuote( quoteItem ) {

        this.$store.dispatch('fncSetupQuoteEdit', quoteItem);

        //this.$store.commit('fncSetEditLoading', true);
        //this.$store.dispatch('fncSetupQuoteEdit', quoteItem);
        /*var modalDetails = { title: 'Update Details - ' + quoteItem.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: quoteItem } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });*/
      },
      fncViewQuote(quoteItem) {
        this.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: quoteItem.id,
          quote: quoteItem
        });
        /*var modalDetails = { title: 'Quote Details - ' + quoteItem.quote_no, component: 'modal-quote-details', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });*/
        //this.$store.dispatch('fncViewAppQuote', quoteItem);
      },
      fncOpenQuote(quoteItem) {
        this.$store.dispatch('fncViewAppQuote', quoteItem);
      },
      fncGenerateReport() {
        this.$store.commit('fncEmptyQuoteList');
        if (this.objRegion != undefined && this.objRegion[0] == 'null') { this.objRegion.shift() }
        if (this.objStatus != undefined && this.objStatus[0] == 'null') { this.objStatus.shift() }
        if (this.objOriginator != undefined && this.objOriginator[0] == 'null') { this.objOriginator.shift() }
        if (this.objCustomerUser != undefined && this.objCustomerUser[0] == 'null') { this.objCustomerUser.shift() }
        if (this.objProject != undefined && this.objProject[0] == 'null') { this.objProject.shift() }
        if (this.objCustomerCompany != undefined && this.objCustomerCompany[0] == 'null') { this.objCustomerCompany.shift() }
        if (this.objSpecifier != undefined && this.objSpecifier[0] == 'null') { this.objSpecifier.shift() }
        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          reload: true,
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          filter: true
        })
      },
      fncGenerateReportSelectedTab(tab) {
        var quote_age = '';
        var current_quote_age = localStorage.getItem("quote_start_date");
        if( current_quote_age && current_quote_age != '' ) {
          quote_age = current_quote_age;
        }

        if( quote_age == undefined || quote_age == '' ) {
          quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
          quote_age = quote_age.toISOString().split('T')[0];
        }

        var quote_age_end = '';
        var current_quote_age_end = localStorage.getItem("quote_end_date");
        if( current_quote_age_end && current_quote_age_end != '' ) {
          quote_age_end = current_quote_age_end;
        }

        var page_start = 0;
        var page_end = 10000000;
        this.$router.push({path: '/reports/quote-reports-lite', query: {p: 1}});

        this.$store.commit('fncEmptyQuoteList');
        if (this.objRegion != undefined && this.objRegion[0] == 'null') { this.objRegion.shift() }
        if (this.objStatus != undefined && this.objStatus[0] == 'null') { this.objStatus.shift() }
        if (this.objOriginator != undefined && this.objOriginator[0] == 'null') { this.objOriginator.shift() }
        if (this.objCustomerUser != undefined && this.objCustomerUser[0] == 'null') { this.objCustomerUser.shift() }
        if (this.objProject != undefined && this.objProject[0] == 'null') { this.objProject.shift() }
        if (this.objCustomerCompany != undefined && this.objCustomerCompany[0] == 'null') { this.objCustomerCompany.shift() }
        if (this.objSpecifier != undefined && this.objSpecifier[0] == 'null') { this.objSpecifier.shift() }

        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          department: this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
          vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          store: this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
          quoteRegion: this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
          quoteRep: this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
          commercial_kam: this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
          quote_type: this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
          service_type: this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objServiceType,
          commercial_originator: this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
          payloadRefresh: true,
          start_date: quote_age,
          end_date: quote_age_end,
          search: this.search,
          page_start: page_start,
          page_end: page_end,
          selectedTab: tab,
        })
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'objQuoteSettings',
        'quotesLite',
        'quotesLiteFilters',
        'filtersLoading',
        'quoteLiteLoaded',
        'quoteLiteContentClick',
        'quoteSingle',
        'quoteLiteSingle',
        'excelLoading',
        'liteColumns',
        'liteFilterLoaded'
      ]),
      checGoButton()
      {
        let label = this.fncFilterLabel();
        if (label === 'Set date range'){
          return false;
        }

        return true;
      }
    },
    watch: {
      liteColumns() {

        // this.$store.dispatch('fncGetRoleData');

        this.headers = [];

        var columns = this.liteColumns;
        this.liteColumns = this.liteColumns;

        this.headers.push({ text: '', value: '', checked: false  })

        for( var l in columns ) {
          if( columns[l].checked == true ) {
            this.headers.push({ text: columns[l].label, value: columns[l].id, checked: false  });
          }
        }

        var subTab = localStorage.getItem('liteSubTab');

        // now we need to run the data as well
        var dToday = new Date();
        var startDate = this.reportStartDate;

        if( startDate == '' ) {

          var newStartDate = new Date(new Date().setDate(dToday.getDate() - 30));
          startDate = newStartDate.toISOString().split('T')[0];

          this.reportStartDate = startDate;
          localStorage.setItem('reportStartDate', this.reportStartDate);

        }

        var endDate = this.reportEndDate;

        if( endDate == '' ) {
          endDate = dToday.toISOString().split('T')[0];

          this.reportEndDate = endDate;
          localStorage.setItem('reportEndDate', this.reportEndDate);
        }

        if( this.reportStartDate.length > 10 ) {
          var sDate = new Date(this.reportStartDate);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          startDate = start_date;
        }

        if( this.reportEndDate.length > 10 ) {
          var eDate = new Date(this.reportEndDate);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          endDate = end_date;
        }

        if( this.liteColumns.length > 0 ) {
          if( subTab == 'all' || subTab == undefined || subTab == 'undefined' ) {
            this.$store.dispatch({
              'type': 'fncQuoteReportLite',
              'status': this.filterStatus,
              'department': this.filterDepartment,
              'store': this.filterStore,
              'customer': this.filterCustomer,
              'startDate': startDate,
              'endDate': endDate,
              'vendor': this.filterVendor,
              'company': this.filterCompany,
              'originator': this.filterOriginator,
              'project': this.filterProject,
              'service_type': this.filterServiceType,
              'linked_user': this.filterLinkedUser,
              'location': this.filterLocation,
              'customer_telephone': this.filterCustomerTelephone
            });
          } else {
            this.$store.dispatch({
              'type': 'fncQuoteReportLite',
              'status': this.filterStatus,
              'department': this.filterDepartment,
              'store': this.filterStore,
              'customer': this.filterCustomer,
              'startDate': startDate,
              'endDate': endDate,
              'vendor': this.filterVendor,
              'company': this.filterCompany,
              'originator': this.filterOriginator,
              'project': this.filterProject,
              'service_type': this.filterServiceType,
              'linked_user': this.filterLinkedUser,
              'location': this.filterLocation,
              'customer_telephone': this.filterCustomerTelephone,
              'tab': subTab
            });
          }
        }

      },
      filterStatus() {
        if( this.filterStatus.length == 0 ) {
          this.filterStatus = ['all'];
        }
      },
      filterStore() {
        if( this.filterStore.length == 0 ) {
          this.filterStore = ['all'];
        }
      },
      filterDepartment() {
        if( this.filterDepartment.length == 0 ) {
          this.filterDepartment = ['all'];
        }
      },
      filterCustomer() {
        if( this.filterCustomer.length == 0 ) {
          this.filterCustomer = ['all'];
        }
      },
      filterVendor() {
        if( this.filterVendor.length == 0 ) {
          this.filterVendor = ['all'];
        }
      },
      filterCompany() {
        if( this.filterCompany.length == 0 ) {
          this.filterCompany = ['all'];
        }
      },
      filterOriginator() {
        if( this.filterOriginator.length == 0 ) {
          this.filterOriginator = ['all'];
        }
      },
      filterProject() {
        if( this.filterProject.length == 0 ) {
          this.filterProject = ['all'];
        }
      },
      filterServiceType() {
        if( this.filterServiceType.length == 0 ) {
          this.filterServiceType = ['all'];
        }
      },
      filterLinkedUser() {
        if( this.filterLinkedUser.length == 0 ) {
          this.filterLinkedUser = ['all'];
        }
      },
      filterLocation() {
        if( this.filterLocation.length == 0 ) {
          this.filterLocation = ['all'];
        }
      },
      quoteLiteLoaded() {

        if( this.quoteLiteLoaded == true ) {

          var qc = 0;
          for( var q in this.quotesLite ) {

            if( this.liteMainTab == q ) {
              this.activeTab = String(qc);
              var sc = 0;
              for( var qs in this.quotesLite[q] ) {
                if( this.liteSubTab == qs ) {
                  this.activeTabSub = String(sc);
                }
                sc++;
              }
            }

            qc++;
          }

          var startDate = this.reportStartDate;
          var endDate = this.reportEndDate;
          if( this.reportStartDate.length > 10 ) {
            var sDate = new Date(this.reportStartDate);
            sDate.setDate(sDate.getDate() + 1);
            var start_date = sDate.toISOString().split('T')[0];
            startDate = start_date;
          }

          if( this.reportEndDate.length > 10 ) {
            var eDate = new Date(this.reportEndDate);
            eDate.setDate(eDate.getDate() + 1);
            var end_date = eDate.toISOString().split('T')[0];
            endDate = end_date;
          }

          this.$store.dispatch({
            'type': 'getQuotesLiteFilters',
            'status': this.filterStatus,
            'department': this.filterDepartment,
            'store': this.filterStore,
            'customer': this.filterCustomer,
            'startDate': startDate,
            'endDate': endDate,
            'vendor': this.filterVendor,
            'company': this.filterCompany,
            'originator': this.filterOriginator,
            'project': this.filterProject,
            'service_type': this.filterServiceType,
            'linked_user': this.filterLinkedUser,
            'location': this.filterLocation,
            'customer_telephone': this.filterCustomerTelephone
          });

          this.$store.dispatch('fncPopulateDepartments');
          this.$store.dispatch('fncPopulateBranches');
          this.$store.dispatch('fncQuoteColumns', false);
          this.$store.dispatch('fncPopulateStatusList');
        }

      }
    },
    beforeMount() {

      if( this.quoteFilter != '' && this.quoteFilter != '0' ) {

        /*var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];*/

        const dToday = new Date();

        dToday.setDate(dToday.getDate());

        const year = dToday.getFullYear();
        const month = String(dToday.getMonth() + 1).padStart(2, '0');
        const day = String(dToday.getDate()).padStart(2, '0');

        const dateToday = `${year}-${month}-${day}`;

        switch(this.quoteFilter) {
          case 1:
            this.reportStartDate = '';
            this.reportEndDate = dateToday;
            break;
          case 2:
            var d = new Date();
            d.setMonth(d.getMonth() - 6);
            var startDate = d.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case 3:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case 4:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case 5:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case 6:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;      
          case '1':
            this.reportStartDate = '';
            this.reportEndDate = dateToday;
            break;
          case '2':
            var d = new Date();
            d.setMonth(d.getMonth() - 6);
            var startDate = d.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case '3':
            var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case '4':
            var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case '5':
            var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;
          case '6':
            var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
            startDate = startDate.toISOString().split('T')[0];
            this.reportStartDate = startDate;
            this.reportEndDate = dateToday;
            break;          
        }

      }

      if( this.$router.history.current.query.quoteNo != undefined && this.$router.history.current.query.quoteNo != 'undefined' ) {
        this.searchQuoteReport = this.$router.history.current.query.quoteNo;
        localStorage.setItem('reportSearch',this.$router.history.current.query.quoteNo);
      }

      /*if( this.objAuthorize.privileges.indexOf("CAN_VIEW_LITE") == -1 ) {
        this.$router.push({path: '/reports/quote-reports', query: {p: 1}});
      } else {
        this.$store.dispatch('fncLiteColumns');
      }*/

      console.log( 'Dates' );
      console.log( this.reportStartDate );
      console.log( this.reportEndDate );

      this.$store.commit('fncSetQuotesLite', []);
      this.$store.commit('fncSetQuoteLiteLoaded', false);
      this.$store.dispatch('fncLiteColumns');

      /*var statusStorage = JSON.stringify( this.filterStatus )
      localStorage.setItem('reportStatus', statusStorage);

      var departmentStorage = JSON.stringify( this.filterDepartment )
      localStorage.setItem('reportDepartment', departmentStorage);

      var storeStorage = JSON.stringify( this.filterStore )
      localStorage.setItem('reportStore', storeStorage);

      var customerStorage = JSON.stringify( this.filterCustomer )
      localStorage.setItem('reportCustomer', customerStorage);*/



    },
    mounted() {

      // set date checks
      var dateToday = new Date();
      //dateToday.setDate(dateToday.getDate() );

      this.disabledAfter = dateToday;

      if( this.filterStore.length == 0 ) {
        this.filterStore = ['all'];
      }

      if( this.filterDepartment.length == 0 ) {
        this.filterDepartment = ['all'];
      }

      if( this.filterVendor.length == 0 ) {
        this.filterVendor = ['all'];
      }

      if( this.filterCompany.length == 0 ) {
        this.filterCompany = ['all'];
      }

      if( this.filterOriginator.length == 0 ) {
        this.filterOriginator = ['all'];
      }

      /*if( this.filterStatus == '' ) {
        this.filterStatus = ['all'];
      }
      console.log('Storage');
      console.log( this.filterStatus );*/

      /*this.tabKeys['is_cancelled_expired_rejected'] = 1;
      this.tabKeys['is_initial_engagement_quote'] = 2;
      this.tabKeys['is_manufacturer_fulfilment'] = 3;
      this.tabKeys['is_negotiating_customer_approval'] = 4;*/

      this.$store.dispatch('fncPopulateRoles');
    },
    destroyed() {
      console.log("destroyed");

    },

    updated() {
      let elementsArray = document.querySelectorAll('.tabs__container.tabs__container--overflow');
      if (elementsArray.length !== 0){
        elementsArray[0].classList.remove('tabs__container--overflow')
      }
    },
    updated() {
      const tableHeader = document.querySelector('[data-ref="quote_date"]');
      if (tableHeader != null){

        tableHeader.addEventListener('click', this.sortBy);
        tableHeader.style.cursor = 'pointer'

        let span = tableHeader.querySelector("span")
        let div = span.querySelector("div")

        if (this.isDateSortOn){
          let i  = document.getElementById("icon_date");
          if (i != null)
            i.remove()

          const icon = document.createElement('i');
          icon.setAttribute("id", "icon_date");
          icon.innerHTML = (this.sortOrders.quote_date == -1) ?  "Newest quote date" : "Oldest Quote date";
          icon.style.color = 'white !important'
          div.appendChild(icon)
        }

        if (document.getElementById("icon_date_sorting") == null){
          const t = document.createElement('i');
          t.setAttribute("id", "icon_date_sorting");
          t.innerHTML = "<i class=\"material-icons sortIcon\">sort</i>";
          // icon.style.color = 'white !important'
          div.appendChild(t)
        }

      }
      const status = document.querySelector('[data-ref="status"]');
      if (status != null){
        status.addEventListener('click', this.sortByStatus);
        status.style.cursor = 'pointer'
        let span = status.querySelector("span")
        let div = span.querySelector("div")
        let span2 = div.querySelector("span")


        //<v-icon small>arrow_upward</v-icon>
        if (this.isStatusSortOn){
          let i  = document.getElementById("icon_status")
          if (i != null)
            i.remove()


          const icon = document.createElement('i');
          icon.setAttribute("id", "icon_status");
          icon.innerHTML = (this.sortStatus == -1) ?  "Latest status change" : "Oldest status change";
          icon.style.color = 'white !important'
          div.appendChild(icon)
        }

        if (document.getElementById("icon_status_sorting") == null){
          const t = document.createElement('i');
          t.setAttribute("id", "icon_status_sorting");
          t.innerHTML = "<i class=\"material-icons sortIcon\">sort</i>";
          // icon.style.color = 'white !important'
          div.appendChild(t)
        }

      }
    },
    created() {
    var vm = this;

    window.addEventListener('keyup', function (event) {
      if( window.location.href.indexOf('login') != -1 ) {
        if (event.keyCode === 13 && vm.$refs.searchField.isFocused == true) {


        }
      }
    })

},
components: {
DatePicker
}
}
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css';
  @import '../../shared/assets/css/lite-report-style.css';
  @import '../../shared/assets/css/manu-lite-report-style.css';

  .mx-calendar-table .lastMonth, .mx-calendar-table .nextMonth {
    color: #999999 !important;
  }

</style>

<style>
  .quoteLite .quoteSearchHighlight {
    background-color: #90D5FF;
    color: inherit;
    padding: 0 1px;
    font-weight: bold;
  }
</style>
